import { formatPropertyAddress, formatStreetAddress } from '../utils/propertyAddress';
import './MobileMapDisclosure.css';
import SearchFilterPanel from './SearchFilterPanel';
import {SavedPropertyLists,PropertyListPicker,PropertyListMembership} from './PropertyLists';
import MapPlaceLayers from './MapPlaceLayers';
import MapPropertyGrid from './MapPropertyGrid';
import {clusterBubbleIcon,propertyMapIcon} from '../utils/mapMarkerIcons';
import {addIllustratedBasemap} from '../services/illustratedBasemap';
import { propertyFetch } from '../services/idxPropertyClient';
import { loadPropertyMedia, propertyMediaUrls } from '../services/propertyMedia';
import { rememberPropertyPhoto } from '../services/propertyThumbnails';
import PropertyThumbnail from './PropertyThumbnail';
import LegacyMobilePropertyBrowser from './LegacyMobilePropertyBrowser';
import { submitChatLead } from '../services/chatLeadService';
import { writeSaveStorage } from '../services/propertySaveStorage';
import { usePropertySave } from './PropertySaveProvider';
import PropertyLocationMap from './PropertyLocationMap';
import {loadPropertyPage,loadPropertyMap,loadPrivateMapRows} from '../utils/boundedPropertySearch';
import {attachBoundedMap,renderBoundedFeatures,viewportBounds} from '../utils/boundedMapLayer';
import './BoundedMap.css';
import './PropertySearchLayout.css';
import RobustSearchControls from './RobustSearchControls';
import { searchSnapshot, searchQuery, searchFromQuery, assertValidSearch, readSearchError, ROBUST_NAMES } from '../utils/propertySearchFilters';
import { applyManualSearchFilters } from '../utils/manualSearchFilters';
// src/components/ActionButtons.js
import React, { useState, useEffect, useRef } from 'react';
import { chatSearchSnapshot, loadChatProperties, mergeChatProperties } from '../utils/chatPropertySearch';
import { useNavigate } from 'react-router-dom';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.markercluster';
import { SITE_CONFIG } from '../config';
import { SEO_CONFIG } from '../config/seo';
import { decryptPassword } from '../utils/decrypt';
import { useTheme } from '../contexts/ThemeContext';
import AlertPill from './AlertPill';
import PropertyDetailModal from './PropertyDetailModal';
import './ActionButtons.css';
import './MapDarkMode.css';
import HoneypotField, { isHoneypotSubmission } from './HoneypotField';
import './MapControls.css';
import './MapSearchBar.css';

// FLEET_FRONTEND_PACKAGE_2026
const POPULAR_SEARCH_AREAS = Object.keys(SITE_CONFIG.LANDING_PAGE?.CITY_IMAGES || {})
  .slice(0, 6)
  .map((key) => key.toLowerCase().split('_').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' '));

const ActionButtons = ({ activeSection, setActiveSection, isGlobeMap, onGlobeMapClose, onGlobeMapResultsChange, directListingKey, initialCity, user, isAdmin, setUser, setIsAdmin, hidePrompts, closeDetailRef }) => {
  const { favorites, collections, toggleFavorite } = usePropertySave();

  const { isDarkMode } = useTheme();
  const navigate = useNavigate();
  const [listingKey,setListingKey]=useState('');

  const [mapStats,setMapStats]=useState({});
  const [lensMapData,setLensMapData]=useState(null);
  const initialMapRequestRef=useRef(0), initialMapAbortRef=useRef(null),lensAbortRef=useRef(null),chatAbortRef=useRef(null);
  const moreRequestsRef=useRef(new Map()),mapPreviewRequestsRef=useRef(new Map());
  useEffect(()=>()=>{initialMapRequestRef.current++;initialMapAbortRef.current?.abort();lensAbortRef.current?.abort();chatAbortRef.current?.abort();moreRequestsRef.current.forEach(controller=>controller.abort());chatGenerationRef.current++;},[]);

  const sharedSearchRef = useRef(searchFromQuery(window.location.search));
  const [advancedFilters, setAdvancedFilters] = useState(() => Object.fromEntries(Object.entries(sharedSearchRef.current).filter(([key]) => [...ROBUST_NAMES, 'minGarageSpaces', 'newConstruction', 'hasPrivatePool', 'waterfront', 'hasBasement', 'hasAttachedGarage', 'state'].includes(key))));
  const [manualSearchError, setManualSearchError] = useState('');
  const appliedSearchRef = useRef(sharedSearchRef.current);
  const applyManualFilters = query => {
    for(const [key,value] of Object.entries({listingKey,minBathrooms,maxBathrooms,hasPool:hasPool||undefined})) {query.delete(key);if(value!==''&&value!==undefined)query.set(key,String(value));}
    query.delete('communityFeatures');communityFeatures.forEach(value=>query.append('communityFeatures',value));
    if(acreage){query.delete('minLotSizeAcres');query.delete('maxLotSizeAcres');if(acreage==='<5')query.set('maxLotSizeAcres','5');else if(acreage==='5to10'){query.set('minLotSizeAcres','5');query.set('maxLotSizeAcres','10');}else if(acreage==='10+')query.set('minLotSizeAcres','10');}
    if (SITE_CONFIG.SEARCH_STATES && !query.has('state') && !query.has('listOfficeKeyNumeric')) {
      SITE_CONFIG.SEARCH_STATES.forEach(state => query.append('state', state));
    }
    applyManualSearchFilters(query, advancedFilters, sharedSearchRef.current);
    sharedSearchRef.current = null;
    setManualSearchError('');
  };

  const localFavoritesKey = `propertyFavorites_${SITE_CONFIG.SITE_ID}`;
  const [showPrompts, setShowPrompts] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [showSecondMessage, setShowSecondMessage] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [propertyLocation, setPropertyLocation] = useState('');
  const [propertySize, setPropertySize] = useState('');
  const [propertyCondition, setPropertyCondition] = useState('');
  const [sellingTimeline, setSellingTimeline] = useState('');
  const [showThankYouMessage, setShowThankYouMessage] = useState(false);
  const [zipCode, setZipCode] = useState('');
  const [name, setName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [messages, setMessages] = useState([]);
  const messagesContainerRef = useRef(null);
  const chatSearchContextRef = useRef(null);
  const chatGenerationRef = useRef(0);
  const chatRequestInFlightRef = useRef(false);
  const chatPropertyRequestRef = useRef(0);
  const chatSiteId = SITE_CONFIG.SITE_ID;
  const [isThinking, setIsThinking] = useState(false);
  const [isPropertySearching, setIsPropertySearching] = useState(false);

  useEffect(() => {
    chatSearchContextRef.current = null;
    chatRequestInFlightRef.current = false;
    setMessages([]);
    setIsThinking(false);
    setIsPropertySearching(false);
    return () => {
      chatGenerationRef.current += 1;
      chatPropertyRequestRef.current += 1;
    };
  }, [chatSiteId]);
  const [showRegistration, setShowRegistration] = useState(false);
  const [regEmail, setRegEmail] = useState('');
  const [regName, setRegName] = useState('');
  const [regPassword, setRegPassword] = useState('');
  const [regPhoneNumber, setRegPhoneNumber] = useState('');
  const [regFullName, setRegFullName] = useState('');
  const [showLogin, setShowLogin] = useState(false);
  const [loginUsername, setLoginUsername] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [properties, setProperties] = useState([]);
  const [showProperties, setShowProperties] = useState(false);
  const [expandedMap, setExpandedMap] = useState(null);
  const [placesExpandedMapInstance,setPlacesExpandedMapInstance]=useState(null);
  const mapRef = useRef(null);
  const leafletMapRef = useRef(null);
  const [locationInput, setLocationInput] = useState('');
  const [listingKeyInput, setListingKeyInput] = useState('');
  const [globeMap, setGlobeMap] = useState(() => {
    const saved = sessionStorage.getItem('globeMapData');
    if (saved && isGlobeMap && new URLSearchParams(window.location.search).get('saved')==='true') {
      sessionStorage.removeItem('globeMapData');
      try { return JSON.parse(saved); } catch { return null; }
    }
    return null;
  });
  useEffect(() => {
    if (onGlobeMapResultsChange) {
      onGlobeMapResultsChange(Boolean(globeMap));
    }
  }, [globeMap, onGlobeMapResultsChange]);

  const globeMapRef = useRef(null);
  const globeLeafletRef = useRef(null);
  const globeMarkersRef = useRef(null);
  const [propertySubType, setPropertySubType] = useState('');
  const [minBedrooms, setMinBedrooms] = useState('');
  const [maxBedrooms, setMaxBedrooms] = useState('');
  const [minPrice, setMinPrice] = useState('');
  const [maxPrice, setMaxPrice] = useState('');
  const [propertyDetail, setPropertyDetail] = useState(null);
  const [propertyImages, setPropertyImages] = useState({});
  const propertyImagesRef = useRef(propertyImages);
  const [propertyDetailImages, setPropertyDetailImages] = useState([]);
  const [imagesLoading, setImagesLoading] = useState(false);
  const detailRequestRef = useRef(0);
  const [enlargedImage, setEnlargedImage] = useState(null);
  const [enlargedImageIndex, setEnlargedImageIndex] = useState(0);
  const [promptCount, setPromptCount] = useState(0);
  const [sendButtonEnabled, setSendButtonEnabled] = useState(false);
  const [showAgentListings, setShowAgentListings] = useState(false);
  const [propertyType, setPropertyType] = useState('Residential');
  const [likedProperties, setLikedProperties] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(localFavoritesKey) || '[]');
      return new Set(Array.isArray(saved) ? saved : []);
    } catch (error) {
      return new Set();
    }
  });
  useEffect(() => { setLikedProperties?.(favorites); }, [favorites, setLikedProperties]);

  const [savedHomesLoading, setSavedHomesLoading] = useState(false);
  const [savedHomesError, setSavedHomesError] = useState('');
  const [isGlobeMapLoading, setIsGlobeMapLoading] = useState(false);

  const [showCopySuccess, setShowCopySuccess] = useState(false);
  const [showAiStaging, setShowAiStaging] = useState(false);
  const [stagingType, setStagingType] = useState('');
  const [stagingImage, setStagingImage] = useState(null);
  const [stagingLoading, setStagingLoading] = useState(false);
  const [hasMedia, setHasMedia] = useState(false);
  const [minSqft, setMinSqft] = useState('');
  const [maxSqft, setMaxSqft] = useState('');
  const [stories, setStories] = useState('');
  const [minYearBuilt, setMinYearBuilt] = useState('');
  const [maxYearBuilt, setMaxYearBuilt] = useState('');
  const [hasFence, setHasFence] = useState(false);
  const [hasPool, setHasPool] = useState(false);
  const [foundation, setFoundation] = useState('');
  const [schoolDistrict, setSchoolDistrict] = useState('');
  const [communityFeatures, setCommunityFeatures] = useState([]);
  const [acreage, setAcreage] = useState('');
  const [minBathrooms, setMinBathrooms] = useState('');
  const [maxBathrooms, setMaxBathrooms] = useState('');
  const [priceSort, setPriceSort] = useState('');
  const [daysOnMarketSort] = useState('');
  const [listingDateSort, setListingDateSort] = useState('');
  const [mapView, setMapView] = useState(true);
  const [hybridView,setHybridView]=useState(true);
  const [quickFiltersOpen, setQuickFiltersOpen] = useState(false);
  const [mapTrayExpanded,setMapTrayExpanded]=useState(false);
  const [hybridMapInstance,setHybridMapInstance]=useState(null);
  const [activeMapTool,setActiveMapTool]=React.useState(null);
  const setPlacesOpen=React.useCallback(open=>setActiveMapTool(open?'places':null),[]);
  const setAlertsOpen=React.useCallback(open=>setActiveMapTool(open?'alerts':null),[]);
  React.useEffect(()=>setActiveMapTool(null),[propertyDetail,expandedMap,mapView]);
  const [initialCityLoading, setInitialCityLoading] = useState(!!initialCity);
  const [listViewPage, setListViewPage] = useState(0);
  const [itemsPerPage] = useState(6);
  const [openChat, setOpenChat] = useState(false);
  const [showSellerLeadCapture, setShowSellerLeadCapture] = useState(false);
  const [pendingSellerParams, setPendingSellerParams] = useState(null);
  const [pendingBuyerParams, setPendingBuyerParams] = useState(null);
  const [chatLeadSubmitted, setChatLeadSubmitted] = useState(false);

  const [leadName, setLeadName] = useState('');
  const [leadPhone, setLeadPhone] = useState('');
  const [leadEmail, setLeadEmail] = useState('');
  const [showAlertPill, setShowAlertPill] = useState(false);
  const [alertPillState, setAlertPillState] = useState('prompt');
  const alertTriggeredRef = useRef(false);
  const [showEmailSendModal, setShowEmailSendModal] = useState(false);
  const [emailRecipient, setEmailRecipient] = useState('');
  const [emailCustomerName, setEmailCustomerName] = useState('');
  const [emailSubject, setEmailSubject] = useState('');
  const [emailPreviewHtml, setEmailPreviewHtml] = useState('');
  const [emailSending, setEmailSending] = useState(false);
  const [emailGenerating, setEmailGenerating] = useState(false);
  const [emailMode, setEmailMode] = useState('email');
  const [socialCopy, setSocialCopy] = useState(null);
  const [senderEmail, setSenderEmail] = useState('');
  const [senderPassword, setSenderPassword] = useState('');
  const [searchLensEnabled, setSearchLensEnabled] = useState(false);
  const [searchLensProperties, setSearchLensProperties] = useState([]);
  const [searchLensLoading, setSearchLensLoading] = useState(false);
  const [searchLensResultCount, setSearchLensResultCount] = useState(0);
  const [searchLensRadiusMiles, setSearchLensRadiusMiles] = useState(null);
  const [searchLensPosition, setSearchLensPosition] = useState(null);
  const [searchLensSize, setSearchLensSize] = useState('medium');
  const [searchLensDragging, setSearchLensDragging] = useState(false);
  const [searchLensPreview, setSearchLensPreview] = useState(null);
  const searchLensPositionRef = useRef(null);
  const searchLensDragRef = useRef(null);
  const searchLensDebounceRef = useRef(null);
  const searchLensRequestRef = useRef(0);
  const searchLensParamsRef = useRef(null);

  useEffect(() => { propertyImagesRef.current = propertyImages; }, [propertyImages]);
  useEffect(() => { searchLensPositionRef.current = searchLensPosition; }, [searchLensPosition]);

  useEffect(() => {
    if (closeDetailRef) {
      closeDetailRef.current = () => {
        if (enlargedImage) { setEnlargedImage(null); setStagingImage(null); return true; }
        if (propertyDetail) { setPropertyDetail(null); return true; }
        return false;
      };
    }
  }, [closeDetailRef, propertyDetail, enlargedImage]);

  useEffect(() => {
    let cancelled = false;

    try {
      const cached = JSON.parse(localStorage.getItem(`featureFlags_${SITE_CONFIG.SITE_ID}`) || 'null');
      if (cached && typeof cached.openChat === 'boolean') setOpenChat(cached.openChat);
    } catch (e) { /* ignore */ }

    const fetchFeatureFlags = async (attempt = 0) => {
      const retry = () => {
        if (attempt < 3 && !cancelled) {
          setTimeout(() => fetchFeatureFlags(attempt + 1), 1500 * (attempt + 1));
          return true;
        }
        return false;
      };
      try {
        const response = await fetch(`https://tophamtechbe.com/api/treas/idx/v1/feature-flag?siteId=${SITE_CONFIG.SITE_ID}`, {
          headers: { 'X-API-Key': 'treas-api-key-2025' }
        });
        if ((response.status === 429 || response.status >= 500) && retry()) return;
        if (response.ok) {
          const data = await response.json();
          if (cancelled) return;
          setOpenChat(data.openChat || false);
          if (data.senderEmail) setSenderEmail(data.senderEmail);
          if (data.senderEmailPassword) {
            decryptPassword(data.senderEmailPassword).then(pw => { if (pw) setSenderPassword(pw); });
          }
          try {
            localStorage.setItem(`featureFlags_${SITE_CONFIG.SITE_ID}`, JSON.stringify({ openChat: !!data.openChat }));
          } catch (e) { /* ignore */ }
        }
      } catch (error) {
        if (retry()) return;
        console.error('Error fetching feature flags:', error);
      }
    };
    fetchFeatureFlags();
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    const saved = localStorage.getItem('leadInfo');
    if (saved) {
      const { name: n, email: e, phone: p } = JSON.parse(saved);
      if (n) setName(n);
      if (e) setEmail(e);
      if (p) setPhoneNumber(p);
    }
  }, []);

  const scrollToBottom = () => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    if (showRegistration || showLogin || selectedService) {
      setTimeout(scrollToBottom, 200);
    }
  }, [showRegistration, showLogin, selectedService]);

  // Handle direct listing access
  useEffect(() => {
    if (directListingKey && isGlobeMap) {
      fetchPropertyDetailByListingKey(directListingKey);
      sessionStorage.removeItem('directListingKey');
    }
  }, [directListingKey, isGlobeMap]);

  // Auto-run search from URL params (shareable search links)
  useEffect(() => {
    if (!isGlobeMap || directListingKey || initialCity) return;
    const params = new URLSearchParams(window.location.search);
    if (params.get('saved') === 'true') return;
    if (params.get('view') === 'filters') {
      params.set('view', 'map');
      window.history.replaceState(window.history.state, '', `/search?${params}`);
    }
    const q = params.get('location') || params.get('q') || params.get('city') || params.get('zip') || params.get('address') || params.get('state') || SITE_CONFIG.PROPERTY_SEARCH?.DEFAULT_LOCATION || SEO_CONFIG.CITY || SITE_CONFIG.STATE;
    const isSearchLensLink = params.get('searchLens') === 'true';
    setLocationInput(q);
    setIsGlobeMapLoading(true);
    // Set filter state from URL params
    if (params.get('propertyType')) setPropertyType(params.get('propertyType'));
    if (params.get('propertySubType')) setPropertySubType(params.get('propertySubType'));
    if (params.get('minBedrooms')) setMinBedrooms(params.get('minBedrooms'));
    if (params.get('maxBedrooms')) setMaxBedrooms(params.get('maxBedrooms'));
    if (params.get('minPrice')) setMinPrice(params.get('minPrice'));
    if (params.get('maxPrice')) setMaxPrice(params.get('maxPrice'));
    if (params.get('minSqft')) setMinSqft(params.get('minSqft'));
    if (params.get('maxSqft')) setMaxSqft(params.get('maxSqft'));
    if (params.get('stories')) setStories(params.get('stories'));
    if (params.get('minYearBuilt')) setMinYearBuilt(params.get('minYearBuilt'));
    if (params.get('maxYearBuilt')) setMaxYearBuilt(params.get('maxYearBuilt'));
    if (params.get('hasFence') === 'true') setHasFence(true);
    if (params.get('foundation')) setFoundation(params.get('foundation'));
    if (params.get('schoolDistrict')) setSchoolDistrict(params.get('schoolDistrict'));
    if (params.get('priceSort')) setPriceSort(params.get('priceSort'));
    if (params.get('hasMedia') === 'true') setHasMedia(true);
    if (isSearchLensLink) setSearchLensEnabled(true);
    fetchPropertiesForGlobe(q, isSearchLensLink).finally(() => setIsGlobeMapLoading(false));
  }, [isGlobeMap]);

  // Auto-load properties when initialCity is provided from area dropdown
  useEffect(() => {
    if (!isGlobeMap || !initialCity) return;
    setInitialCityLoading(true);
    fetchPropertiesForGlobe(initialCity).finally(() => setInitialCityLoading(false));
  }, [isGlobeMap, initialCity]);

  useEffect(() => {
    if (expandedMap && mapRef.current) {
      // Clean up existing map
      if (leafletMapRef.current) {
        leafletMapRef.current.remove();
      }

      // Create new map
      const map = L.map(mapRef.current,{minZoom:1,maxZoom:19}).setView([expandedMap.lat, expandedMap.lon], 15);

      addIllustratedBasemap(map);

      // Add house marker
      const houseIcon = L.divIcon({
        html: '🏠',
        className: 'house-marker',
        iconSize: [30, 30],
        iconAnchor: [15, 15]
      });

      L.marker([expandedMap.lat, expandedMap.lon], { icon: houseIcon }).addTo(map);

      leafletMapRef.current = map;
      setPlacesExpandedMapInstance(map);
    }

    return () => {
      if (leafletMapRef.current) {
        leafletMapRef.current.remove();
        leafletMapRef.current = null;
        setPlacesExpandedMapInstance(null);
      }
    };
  }, [expandedMap]);

  const commonPrompts = [
    { display: "Sign in", value: "Sign in" },
    { display: zipCode ? `Show me properties in ${zipCode}` : "Show me properties", value: zipCode ? `Show me properties in ${zipCode}` : "Show me properties" },
    { display: "Register", value: "Register" },
    { display: "Contact Sandy Hopkins", value: "Contact Sandy Hopkins" },
    { display: "About us", value: "About us" },
    { display: "Contact Info", value: "What is the real estate agents contact info" }
  ];

  const handlePromptSelect = (promptValue) => {
    setInputValue(promptValue);
    setShowPrompts(false);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = isHoneypotSubmission(e.currentTarget) ? { ok: true } : await submitChatLead(new URL(`https://tophamtechbe.com/api/treas/idx/v1/chatleads?postalCode=${encodeURIComponent(zipCode)}&name=${encodeURIComponent(name)}&phoneNumber=${encodeURIComponent(phoneNumber)}&serviceReq=${encodeURIComponent(selectedService)}&email=${encodeURIComponent(email)}&siteId=${SITE_CONFIG.SITE_ID}`).searchParams, { rememberContact: true });

      if (response.ok) {
        console.log('Form submitted successfully');
        // Clear form but keep customer info for later use
        // setZipCode(''); // Keep zip code for property search
        // Keep name, phone, email for selling details form
        // setName('');
        // setPhoneNumber('');
        // setEmail('');
        // Show thank you message
        setShowThankYouMessage(true);
        setTimeout(scrollToBottom, 200);
      } else {
        console.error('Form submission failed');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (!inputValue.trim() || chatRequestInFlightRef.current || isPropertySearching) return;

    // Add user message
    const userMessage = { type: 'user', content: inputValue };
    setMessages(prev => [...prev, userMessage]);
    setPromptCount(prev => prev + 1);

    const messageToSend = inputValue;
    const lowerMessage = inputValue.toLowerCase();
    setInputValue('');

    // Check for sign in keywords
    if (lowerMessage.includes('sign in') || lowerMessage.includes('signin') || lowerMessage.includes('login') || lowerMessage.includes('log in')) {
      setShowLogin(true);
      const botMessage = { type: 'bot', content: 'I\'ll help you sign in. Please enter your credentials below:' };
      setMessages(prev => [...prev, botMessage]);
      return;
    }

    chatRequestInFlightRef.current = true;
    const generation = chatGenerationRef.current;
    setIsThinking(true);
    try {
      const response = await fetch('https://tophamtechbe.com/llm/v1/chat', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          capabilities: ['robust_search_v1'],
          message: messageToSend,
          site_id: SITE_CONFIG.SITE_ID,
          ...(chatSearchContextRef.current?.siteId === chatSiteId
            ? { search_context: chatSearchContextRef.current.params } : {}),
          conversation_history: messages.filter(msg => msg.content !== 'properties').map(msg => ({
            role: msg.type === 'user' ? 'user' : 'assistant',
            content: msg.content
          }))
        })
      });

      if (response.ok) {
        const data = await response.json();
        if (generation !== chatGenerationRef.current) return;
        // Add bot response
        const botMessage = { type: 'bot', content: data.response };
        setMessages(prev => [...prev, botMessage]);

        // Handle action if present
        if (data.action) {
          console.log('Action received:', data.action, data.params);
          await handleAction(data.action, data.params);
        }
      } else {
        if (generation !== chatGenerationRef.current) return;
        const errorMessage = { type: 'bot', content: 'Sorry, I\'m having trouble connecting right now. Please try again later.' };
        setMessages(prev => [...prev, errorMessage]);
      }
    } catch (error) {
      if (generation !== chatGenerationRef.current) return;
      console.error('Error sending message:', error);
      const errorMessage = { type: 'bot', content: 'Sorry, I\'m having trouble connecting right now. Please try again later.' };
      setMessages(prev => [...prev, errorMessage]);
    } finally {
      if (generation === chatGenerationRef.current) {
        chatRequestInFlightRef.current = false;
        setIsThinking(false);
      }
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSendMessage(e);
    }
  };

  const submitSellerInquiry = async (params, userEmail, userName, userPhone) => {
    try {
      const queryParams = new URLSearchParams({
        location: params.location,
        propertyDetails: params.property_details,
        email: userEmail,
        phoneNumber: userPhone,
        name: userName,
        siteId: SITE_CONFIG.SITE_ID
      });

      if (params.address) {
        queryParams.append('address', params.address);
      }

      const response = await fetch(`https://tophamtechbe.com/api/treas/idx/v1/selling-inquiry?${queryParams}`, {
        method: 'POST',
        headers: {
          'X-API-Key': 'treas-api-key-2025'
        }
      });

      if (response.ok) {
        console.log('Seller inquiry submitted successfully');
      } else {
        console.error('Failed to submit seller inquiry');
      }
    } catch (error) {
      console.error('Error submitting seller inquiry:', error);
    }
  };

  const storeConversation = async (params) => {
    try {
      const queryParams = new URLSearchParams({
        reason: params.reason || 'inquiry',
        contactInfo: email || params.contactInfo || '',
        conversationSummary: params.conversationSummary || '',
        phone: phoneNumber || params.phone || '',
        name: name || params.name || '',
        siteId: SITE_CONFIG.SITE_ID
      });

      const response = await fetch(`https://tophamtechbe.com/api/treas/idx/v1/store-convo?${queryParams}`, {
        method: 'POST',
        headers: {
          'X-API-Key': 'treas-api-key-2025'
        }
      });

      if (response.ok) {
        console.log('Conversation stored successfully');
      } else {
        console.error('Failed to store conversation');
      }
    } catch (error) {
      console.error('Error storing conversation:', error);
    }
  };

  const sendAgentSMS = async (customerName, customerPhone) => {
    try {
      const formData = new FormData();
      formData.append('to', SITE_CONFIG.AGENT.PHONE);
      formData.append('body', `Agent Winds Message: ${customerName} has requested you contact them at ${customerPhone}`);

      const response = await fetch('https://tophamtechbe.com/api/treas/comm/send-sms', {
        method: 'POST',
        headers: {
          'X-API-Key': 'treas-api-key-2025'
        },
        body: formData
      });

      if (response.ok) {
        console.log('SMS sent to agent successfully');
      } else {
        console.error('Failed to send SMS to agent');
      }
    } catch (error) {
      console.error('Error sending SMS to agent:', error);
    }
  };

  const handleGetCRM = async () => {
    const userEmail = user?.email || email;
    if (!userEmail) {
      const botMessage = { type: 'bot', content: 'Please sign in to view your progress status.' };
      setMessages(prev => [...prev, botMessage]);
      return;
    }

    try {
      const response = await fetch(`https://tophamtechbe.com/api/treas/idx/v1/crm?email=${encodeURIComponent(userEmail)}&siteId=${SITE_CONFIG.SITE_ID}`, {
        headers: {
          'X-API-Key': 'treas-api-key-2025'
        }
      });

      if (response.ok) {
        const data = await response.json();
        const stages = ['lead', 'discover', 'onboard', 'research', 'offer', 'inspection', 'closing', 'complete'];
        const stageLabels = {
          lead: 'Initial Lead',
          discover: 'Discovery Call',
          onboard: 'Client Onboard',
          research: 'Market Research',
          offer: 'Make Offer',
          inspection: 'Home Inspection',
          closing: 'Closing Process',
          complete: 'Deal Complete'
        };

        let currentStage = null;
        let currentNote = null;

        // Find the furthest non-null stage
        for (let i = stages.length - 1; i >= 0; i--) {
          const stage = stages[i];
          if (data[stage] !== null) {
            currentStage = stage;
            currentNote = data[`${stage}Note`];
            break;
          }
        }

        let statusMessage;
        if (currentStage) {
          const stageLabel = stageLabels[currentStage];
          const status = data[currentStage];
          statusMessage = `🏠 **Current Status: ${stageLabel}**\n\n📊 Status: ${status}`;
          if (currentNote) {
            statusMessage += `\n📝 Note: ${currentNote}`;
          }
        } else {
          statusMessage = '🏠 **Your Progress**\n\nNo progress recorded yet. Contact us to get started!';
        }

        const botMessage = { type: 'bot', content: statusMessage };
        setMessages(prev => [...prev, botMessage]);
      } else {
        const botMessage = { type: 'bot', content: 'No progress information found. Contact us to get started with your real estate journey!' };
        setMessages(prev => [...prev, botMessage]);
      }
    } catch (error) {
      console.error('Error fetching CRM data:', error);
      const botMessage = { type: 'bot', content: 'Unable to retrieve your progress at this time. Please try again later.' };
      setMessages(prev => [...prev, botMessage]);
    }
  };

  const fetchLikedProperties = async () => {
    const userEmail = user?.email || email;
    if (!userEmail) {
      const botMessage = { type: 'bot', content: 'Please sign in to view your liked properties.' };
      setMessages(prev => [...prev, botMessage]);
      return;
    }

    try {
      const response = await fetch(`https://tophamtechbe.com/api/treas/idx/v1/interested-buy?email=${encodeURIComponent(userEmail)}`, {
        headers: {
          'X-API-Key': 'treas-api-key-2025'
        }
      });

      if (response.ok) {
        const likedData = await response.json();
        if (likedData.length === 0) {
          const botMessage = { type: 'bot', content: 'You haven\'t liked any properties yet.' };
          setMessages(prev => [...prev, botMessage]);
          return;
        }

        const listingKeys = likedData.map(item => item.listingKey);
        const propertiesPromises = listingKeys.map(key =>
          propertyFetch(`https://tophamtechbe.com/api/treas/idx/v1/retrieve-property-summary?listingKey=${key}`, {}).then(res => res.json())
        );

        const propertiesResults = await Promise.all(propertiesPromises);
        const likedProperties = propertiesResults
          .map(result => result.properties?.[0])
          .filter(prop => prop);

        if (likedProperties.length > 0) {
          const propertiesMessage = {
            type: 'bot',
            content: 'properties',
            properties: likedProperties,
            currentPage: 0
          };
          setMessages(prev => [...prev, propertiesMessage]);
        }
      }
    } catch (error) {
      console.error('Error fetching liked properties:', error);
      const botMessage = { type: 'bot', content: 'Unable to retrieve your liked properties at this time.' };
      setMessages(prev => [...prev, botMessage]);
    }
  };

  const handleAction = async (action, params = {}) => {
    // Close any existing forms first
    setShowRegistration(false);
    setShowLogin(false);

    if (action === 'show_registration') {
      setRegEmail(params.email || '');
      setRegName(params.name || '');
      setShowRegistration(true);
    } else if (action === 'show_login') {
      setLoginUsername(params.email || '');
      setShowLogin(true);
    } else if (action === 'show_map') {
      setShowProperties(true);
      return fetchProperties(params);
    } else if (action === 'collecting_buyer_info') {
      // Clarification does not start a property search.
      return;
    } else if (action === 'get_liked_properties') {
      fetchLikedProperties();
    } else if (action === 'seller_inquiry') {
      const userEmail = user?.email || email;
      const userName = user?.username || name;
      const userPhone = user?.phoneNumber || phoneNumber;

      if (userName && userPhone && userEmail) {
        submitSellerInquiry(params, userEmail, userName, userPhone);
      } else {
        setPendingSellerParams(params);
        setMessages(prev => [...prev, { type: 'bot', content: 'seller_lead_capture' }]);
        setTimeout(scrollToBottom, 200);
      }
    } else if (action === 'buying_inquiry') {
      // Per the chat spec, buying_inquiry = serious purchase intent = a LEAD moment, NOT a
      // property browse (browsing/searching returns show_map, which is what renders listings).
      // So capture the lead if we don't have it yet; otherwise just let the bot's reply
      // continue the conversation. Do NOT fetch/dump properties here.
      if (!(user || chatLeadSubmitted)) {
        setPendingBuyerParams(params);
        setMessages(prev => [...prev, { type: 'bot', content: 'buyer_lead_capture' }]);
        setTimeout(scrollToBottom, 200);
      }
      // else: already a known lead — the bot's conversational reply drives the next step.
    } else if (action === 'storeConvo') {
      storeConversation(params);
    } else if (action === 'get-crm') {
      handleGetCRM();
    } else if (action === 'agent_contact_request') {
      const userName = user?.username || name;
      const userPhone = user?.phoneNumber || phoneNumber;

      if (userName && userPhone) {
        sendAgentSMS(userName, userPhone);
      } else {
        setMessages(prev => [...prev, { type: 'bot', content: 'agent_contact_capture' }]);
        setTimeout(scrollToBottom, 200);
      }
    } else if (action === 'property_alert') {
      const searchFilters = searchSnapshot(params.searchFilters || params);

      const subPayload = {
        customerName: params.name,
        agentName: SITE_CONFIG.AGENT.NAME,
        emailAddress: params.email,
        siteId: SITE_CONFIG.SITE_ID,
        cadence: params.cadence || 'daily',
        listingBaseUrl: window.location.origin,
        ...(senderEmail && { senderEmail }),
        ...(senderPassword && { emailPassword: senderPassword }),
        searchFilters,
      };

      const leadParams = new URLSearchParams({
        name: params.name,
        email: params.email,
        postalCode: params.postalCode,
        serviceReq: params.serviceReq || 'buying',
        siteId: SITE_CONFIG.SITE_ID,
      });
      if (params.phoneNumber) leadParams.set('phoneNumber', params.phoneNumber);
      if (params.city) leadParams.set('area', params.city);

      Promise.all([
        fetch('https://tophamtechbe.com/api/treas/comm/property-search-subscriptions', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-API-Key': 'treas-api-key-2025' },
          body: JSON.stringify(subPayload),
        }),
        submitChatLead(new URL(`https://tophamtechbe.com/api/treas/idx/v1/chatleads?${leadParams}`).searchParams, { rememberContact: true }),
      ]).then(([subRes, leadRes]) => {
        if (!subRes.ok || !leadRes.ok) throw new Error('API call failed');
      }).catch(() => {
        setMessages(prev => [...prev, { type: 'bot', content: 'Sorry, there was an issue setting up your alert. Please try again.' }]);
        setTimeout(scrollToBottom, 200);
      });
    }
  };

  const handleRegistrationSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('https://tophamtechbe.com/api/treas/auth/signup', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username: regName,
          email: regEmail,
          password: regPassword,
          phoneNumber: regPhoneNumber,
          name: regFullName,
          siteId: SITE_CONFIG.SITE_ID
        })
      });

      if (response.ok) {
        // Registration successful, now sign them in automatically
        try {
          const signInResponse = await fetch('https://tophamtechbe.com/api/treas/auth/signin', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              username: regName,
              password: regPassword,
              siteId: SITE_CONFIG.SITE_ID
            })
          });

          if (signInResponse.ok) {
            const userData = await signInResponse.json();
            setUser(userData);
            setIsAdmin(userData.roles?.includes('ROLE_ADMIN') || userData.roles?.includes('ROLE_ASSISTANT') || false);
            localStorage.setItem('user', JSON.stringify(userData));

            const botMessage = { type: 'bot', content: 'Registration successful! You are now signed in. How can I help you today?' };
            setMessages(prev => [...prev, botMessage]);
          } else {
            const botMessage = { type: 'bot', content: 'Registration successful! Please sign in with your new credentials.' };
            setMessages(prev => [...prev, botMessage]);
            setShowLogin(true);
          }
        } catch (error) {
          console.error('Auto sign-in error:', error);
          const botMessage = { type: 'bot', content: 'Registration successful! Please sign in with your new credentials.' };
          setMessages(prev => [...prev, botMessage]);
          setShowLogin(true);
        }

        setShowRegistration(false);
        setRegEmail('');
        setRegName('');
        setRegPassword('');
        setRegPhoneNumber('');
        setRegFullName('');
        setShowThankYouMessage(true); // Unlock send button
      } else {
        const errorData = await response.text();
        console.log('Registration error response:', errorData);
        const botMessage = { type: 'bot', content: 'Registration failed. Please try again.' };
        setMessages(prev => [...prev, botMessage]);
      }
    } catch (error) {
      console.error('Registration error:', error);
      const botMessage = { type: 'bot', content: 'Registration failed. Please try again.' };
      setMessages(prev => [...prev, botMessage]);
    }
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('https://tophamtechbe.com/api/treas/auth/signin', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username: loginUsername,
          password: loginPassword,
          siteId: SITE_CONFIG.SITE_ID
        })
      });

      if (response.ok) {
        const userData = await response.json();

        // Check if siteId matches
        if (userData.siteId?.toLowerCase() !== SITE_CONFIG.SITE_ID.toLowerCase()) {
          const botMessage = { type: 'bot', content: 'Access denied. You are not authorized for this site.' };
          setMessages(prev => [...prev, botMessage]);
          return;
        }

        // Set user data and check for admin role
        setUser(userData);
        setIsAdmin(userData.roles?.includes('ROLE_ADMIN') || userData.roles?.includes('ROLE_ASSISTANT') || false);
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('user', JSON.stringify(userData));

        const botMessage = { type: 'bot', content: 'Login successful! Welcome back. How can I help you today?' };
        setMessages(prev => [...prev, botMessage]);
        setShowLogin(false);
        setLoginUsername('');
        setLoginPassword('');
        setShowThankYouMessage(true); // Unlock send button
      } else {
        const errorData = await response.text();
        console.log('Login error response:', errorData);
        const botMessage = { type: 'bot', content: 'Login failed. Please check your credentials.' };
        setMessages(prev => [...prev, botMessage]);
      }
    } catch (error) {
      console.error('Login error:', error);
      const botMessage = { type: 'bot', content: 'Login failed. Please try again.' };
      setMessages(prev => [...prev, botMessage]);
    }
  };

  const handlePasswordResetSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('https://tophamtechbe.com/api/treas/auth/password-reset', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: resetEmail,
          baseUrl: window.location.origin,
          siteId: SITE_CONFIG.SITE_ID
        })
      });

      if (response.ok) {
        const botMessage = { type: 'bot', content: 'Password reset link sent to your email. Please check your inbox.' };
        setMessages(prev => [...prev, botMessage]);
        setShowForgotPassword(false);
        setShowLogin(false);
        setResetEmail('');
      } else {
        const botMessage = { type: 'bot', content: 'Failed to send reset link. Please try again.' };
        setMessages(prev => [...prev, botMessage]);
      }
    } catch (error) {
      console.error('Password reset error:', error);
      const botMessage = { type: 'bot', content: 'Failed to send reset link. Please try again.' };
      setMessages(prev => [...prev, botMessage]);
    }
  };

  const fetchProperties = async (params) => {
    chatAbortRef.current?.abort();const controller=new AbortController();chatAbortRef.current=controller;
    const snapshot = chatSearchSnapshot(params, SITE_CONFIG.STATE);
    const generation = chatGenerationRef.current;
    const requestId = ++chatPropertyRequestRef.current;
    const isCurrent = () => generation === chatGenerationRef.current && requestId === chatPropertyRequestRef.current;
    setIsPropertySearching(true);
    try {
      const result = await loadPropertyPage({
        pageSize:itemsPerPage,queryOptions:{firstPhoto:true},signal:controller.signal,
        params: snapshot,
        siteId: SITE_CONFIG.SITE_ID,

        privateApiKey: 'treas-api-key-2025'
      });
      if (!isCurrent()) return;
      // Replace the entire prior search. Merging would resurrect removed filters.
      chatSearchContextRef.current = { siteId: chatSiteId, params: snapshot };
      setProperties(result.properties);
      setMessages(prev => [...prev, {
        type: 'bot',
        content: 'properties',
        properties: result.properties,
        privateUnavailable: result.privateUnavailable,
        pageState:result.pageState,hasMore:result.hasMore,searchFilters:snapshot,searchId:requestId,
        currentPage: 0
      }]);
    } catch (error) {
      if (!isCurrent()) return;
      console.error('Error fetching chat properties:', error);
      setMessages(prev => [...prev, {
        type: 'bot',
        content: "I couldn't load the property search right now. " + (error.message || "Please try again.")
      }]);
    } finally {
      if (isCurrent()) setIsPropertySearching(false);
    }
  };

  const getTileCoords = (lat, lon, zoom) => {
    const x = Math.floor((lon + 180) / 360 * Math.pow(2, zoom));
    const y = Math.floor((1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * Math.pow(2, zoom));
    return { x, y };
  };

  const getPropertyCoords = (property) => {
    // Use actual lat/lon from property data, fallback to Maricopa coordinates
    const lat = property.latitude || 33.0581;
    const lon = property.longitude || -112.0476;
    return { lat, lon };
  };

  const isMobileViewport = () => window.innerWidth <= 768;

  const getDefaultSearchLensSize = () => isMobileViewport() ? 'small' : 'medium';

  const getLensDiameter = () => {
    const sizes = isMobileViewport()
      ? { small: 182, medium: 221, large: 273 }
      : { small: 234, medium: 286, large: 364 };
    return sizes[searchLensSize] || sizes.medium;
  };

  const buildPropertySearchParams = (location, includeLocation = true) => {
    const queryParams = new URLSearchParams();

    if (includeLocation && location) {
      if (/^\d{5}$/.test(location.trim())) {
        queryParams.append('zip', location.trim());
      } else if (/\d/.test(location) && /[a-zA-Z]/.test(location)) {
        queryParams.append('address', location.trim());
      } else if (location.length === 2) {
        queryParams.append('state', location.toUpperCase());
      } else {
        const stateMap = {
          'alabama': 'AL', 'alaska': 'AK', 'arizona': 'AZ', 'arkansas': 'AR', 'california': 'CA',
          'colorado': 'CO', 'connecticut': 'CT', 'delaware': 'DE', 'florida': 'FL', 'georgia': 'GA',
          'hawaii': 'HI', 'idaho': 'ID', 'illinois': 'IL', 'indiana': 'IN', 'iowa': 'IA',
          'kansas': 'KS', 'kentucky': 'KY', 'louisiana': 'LA', 'maine': 'ME', 'maryland': 'MD',
          'massachusetts': 'MA', 'michigan': 'MI', 'minnesota': 'MN', 'mississippi': 'MS', 'missouri': 'MO',
          'montana': 'MT', 'nebraska': 'NE', 'nevada': 'NV', 'new hampshire': 'NH', 'new jersey': 'NJ',
          'new mexico': 'NM', 'new york': 'NY', 'north carolina': 'NC', 'north dakota': 'ND', 'ohio': 'OH',
          'oklahoma': 'OK', 'oregon': 'OR', 'pennsylvania': 'PA', 'rhode island': 'RI', 'south carolina': 'SC',
          'south dakota': 'SD', 'tennessee': 'TN', 'texas': 'TX', 'utah': 'UT', 'vermont': 'VT',
          'virginia': 'VA', 'washington': 'WA', 'west virginia': 'WV', 'wisconsin': 'WI', 'wyoming': 'WY'
        };

        const stateAbbr = stateMap[location.toLowerCase().trim()];
        if (stateAbbr) {
          queryParams.append('state', stateAbbr);
        } else {
          queryParams.append('city', location);
        }
      }
    }

    if (propertyType) queryParams.append('propertyType', propertyType);
    if (propertySubType) queryParams.append('propertySubType', propertySubType);
    if (minBedrooms) queryParams.append('minBedrooms', minBedrooms);
    if (maxBedrooms) queryParams.append('maxBedrooms', maxBedrooms);
    if (minPrice) queryParams.append('minPrice', minPrice);
    if (maxPrice) queryParams.append('maxPrice', maxPrice);
    if (minSqft) queryParams.append('minSqft', minSqft);
    if (maxSqft) queryParams.append('maxSqft', maxSqft);
    if (stories) queryParams.append('stories', stories);
    if (minYearBuilt) queryParams.append('minYearBuilt', minYearBuilt);
    if (maxYearBuilt) queryParams.append('maxYearBuilt', maxYearBuilt);
    if (hasFence) queryParams.append('hasFence', 'true');
    if (hasPool) queryParams.append('hasPool', 'true');
    if (foundation) queryParams.append('foundation', foundation);
    if (schoolDistrict) queryParams.append('schoolDistrict', schoolDistrict);
    if (communityFeatures.length > 0) {
      communityFeatures.forEach(f => queryParams.append('communityFeatures', f));
    }
    if (acreage === '<5') { queryParams.append('maxLotSizeAcres', '5'); }
    else if (acreage === '5to10') { queryParams.append('minLotSizeAcres', '5'); queryParams.append('maxLotSizeAcres', '10'); }
    else if (acreage === '10+') { queryParams.append('minLotSizeAcres', '10'); }
    if (minBathrooms) queryParams.append('minBathrooms', minBathrooms);
    if (maxBathrooms) queryParams.append('maxBathrooms', maxBathrooms);
    if (priceSort) queryParams.append('priceSort', priceSort);
    if (daysOnMarketSort) queryParams.append('daysonmarketSort', daysOnMarketSort);
    if (listingDateSort) queryParams.append('listingDateSort', listingDateSort);
    if (showAgentListings) queryParams.append('listOfficeKey', SITE_CONFIG.AGENT.BROKERAGE_LICENSE);
    if (hasMedia) queryParams.append('hasMedia', 'true');

    queryParams.set('state', SITE_CONFIG.STATE);
    return queryParams;
  };

  const getDefaultSearchLensCenter = () => ({
    lat: parseFloat(SITE_CONFIG.LATITUDE) || 30.2672,
    lon: parseFloat(SITE_CONFIG.LONGITUDE) || -97.7431
  });

  const getDefaultSearchLensLabel = () => {
    const parts = [SEO_CONFIG.CITY, SEO_CONFIG.STATE].filter(Boolean);
    return parts.length > 0 ? parts.join(', ') : 'Search Lens';
  };

  const geocodeSearchLocation = async (location) => {
    if (!location?.trim()) return getDefaultSearchLensCenter();

    try {
      const query = `${location}, ${SITE_CONFIG.STATE}`;
      const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=1`);
      const data = await response.json();
      if (data.length > 0) {
        return {
          lat: parseFloat(data[0].lat),
          lon: parseFloat(data[0].lon)
        };
      }
    } catch (error) {
      console.error('Geocoding error:', error);
    }
    return getDefaultSearchLensCenter();
  };

  const getLensQuery = (map) => {
    const position = searchLensPositionRef.current;
    if (!map || !position) return null;
    const radiusPixels = getLensDiameter() / 2;
    const centerPoint = L.point(position.x, position.y);
    const edgePoint = L.point(position.x + radiusPixels, position.y);
    const centerLatLng = map.containerPointToLatLng(centerPoint);
    const edgeLatLng = map.containerPointToLatLng(edgePoint);
    const radiusMiles = centerLatLng.distanceTo(edgeLatLng) / 1609.344;
    return { centerLatLng, radiusMiles };
  };

  const renderPropertyMarkers = (map, propertyList, useClusters) => {
    if (!map) return;
    if (globeMarkersRef.current) {
      map.removeLayer(globeMarkersRef.current);
      globeMarkersRef.current = null;
    }

    if (!propertyList || propertyList.length === 0) {
      const locationIcon = L.divIcon({
        html: '📍',
        className: 'location-marker',
        iconSize: [30, 30],
        iconAnchor: [15, 15]
      });
      const marker = L.marker([map.getCenter().lat, map.getCenter().lng], { icon: locationIcon });
      globeMarkersRef.current = marker.addTo(map);
      return;
    }

    const layer = useClusters
      ? L.markerClusterGroup({
          maxClusterRadius: 50,
          spiderfyOnMaxZoom: true,
          showCoverageOnHover: false,
          zoomToBoundsOnClick: true
        , iconCreateFunction: cluster => clusterBubbleIcon(cluster.getChildCount())})
      : L.layerGroup();

    propertyList.forEach(property => {
      if (property.latitude && property.longitude) {
        const price = property.list_price || property.current_price || property.price || 'N/A';
        const houseIcon = propertyMapIcon(property.current_price ?? property.price,{isPrivate:property.isPrivate});

        const marker = L.marker([property.latitude, property.longitude], { icon: houseIcon });
        const listingKey = property.listing_key;

        marker.on('mouseover', function () {
          prefetchPropertyDetail(property);
          const cachedImg = propertyImagesRef.current[listingKey];
          if (cachedImg) {
            if (!useClusters) {
              const point = map.latLngToContainerPoint([property.latitude, property.longitude]);
              setSearchLensPreview({
                imageUrl: cachedImg,
                x: point.x,
                y: point.y
              });
              return;
            }
            this.bindTooltip(
              `<img src="${cachedImg}" class="thumbnail-tooltip-image" />`,
              {
                direction: 'top',
                offset: [0, -10],
                className: 'thumbnail-tooltip',
                pane: map.getPane('searchLensPreviewPane') ? 'searchLensPreviewPane' : 'tooltipPane'
              }
            ).openTooltip();
          }
        });
        marker.on('mouseout', function () {
          if (!useClusters) {
            setSearchLensPreview(null);
            return;
          }
          this.unbindTooltip();
        });
        marker.on('click', () => {
          setSearchLensPreview(null);
          if (property.isPrivate) {
            fetchPrivatePropertyDetail(property);
          } else if (property.id) {
            fetchPropertyDetail(property.id, property);
          }
        });

        layer.addLayer(marker);
      }
    });

    layer.addTo(map);
    globeMarkersRef.current = layer;
  };

  const fetchSearchLensProperties = async (map) => {
    const activeSearchParams = searchLensParamsRef.current || globeMap?.searchParams;
    if (!globeMap?.isSearchLens || !activeSearchParams) return;
    const lensQuery = getLensQuery(map);
    if (!lensQuery) return;

    const requestId = searchLensRequestRef.current + 1;
    searchLensRequestRef.current = requestId;
    setSearchLensLoading(true);
    setSearchLensRadiusMiles(lensQuery.radiusMiles);

    const queryParams = searchQuery(activeSearchParams);
    queryParams.set('centerLat', lensQuery.centerLatLng.lat.toFixed(6));
    queryParams.set('centerLng', lensQuery.centerLatLng.lng.toFixed(6));
    queryParams.set('radiusMiles', lensQuery.radiusMiles.toFixed(4));

    try {
      assertValidSearch(searchFromQuery(queryParams));
      setManualSearchError('');
      lensAbortRef.current?.abort();const controller=new AbortController();lensAbortRef.current=controller;
      const result=await loadPropertyMap({params:searchFromQuery(queryParams),bounds:viewportBounds(map),zoom:map.getZoom(),signal:controller.signal});
      const data={properties:[],total_count:result.map.match_count};

      if (searchLensRequestRef.current !== requestId) return;
      const nextProperties = data.properties || [];
      appliedSearchRef.current = searchFromQuery(queryParams);
      setSearchLensProperties(nextProperties);setLensMapData(result.map);
      setSearchLensResultCount(data.total_count ?? nextProperties.length);
      nextProperties.slice(0, 25).forEach(property => {
        if (property.listing_key && !propertyImagesRef.current[property.listing_key]) {
          fetchPropertyImage(property.listing_key);
        }
      });
    } catch (error) {
      if(error.name==='AbortError')return;
      if (searchLensRequestRef.current === requestId) {
        console.error('Error fetching Search Lens properties:', error);
        setManualSearchError(error.message || 'Unable to load Search Lens results.');
      }
    } finally {
      if (searchLensRequestRef.current === requestId) {
        setSearchLensLoading(false);
      }
    }
  };

  const scheduleSearchLensFetch = (map, delay = 350) => {
    lensAbortRef.current?.abort();searchLensRequestRef.current++;
    if (!map) return;
    clearTimeout(searchLensDebounceRef.current);
    searchLensDebounceRef.current = setTimeout(() => fetchSearchLensProperties(map), delay);
  };

  const handleSearchLensSizeChange = (size) => {
    setSearchLensSize(size);
    setTimeout(() => scheduleSearchLensFetch(globeLeafletRef.current, 0), 0);
  };

  const updateSearchLensParam = (key, value) => {
    const current = searchLensParamsRef.current || globeMap?.searchParams || {};
    const next = { ...current };
    if (value) {
      next[key] = value;
    } else {
      delete next[key];
    }
    next.state = SITE_CONFIG.STATE;
    searchLensParamsRef.current = next;
    scheduleSearchLensFetch(globeLeafletRef.current, 0);
  };

  const handleSearchLensMaxPriceChange = (value) => {
    setMaxPrice(value === '0' ? '' : value);
    updateSearchLensParam('maxPrice', value === '0' ? '' : value);
  };

  const handleSearchLensBedroomsChange = (value) => {
    setMinBedrooms(value === '0' ? '' : value);
    updateSearchLensParam('minBedrooms', value === '0' ? '' : value);
  };

  const getPointerPosition = (event) => {
    const source = event.touches?.[0] || event.changedTouches?.[0] || event;
    return { clientX: source.clientX, clientY: source.clientY };
  };

  const clampLensPosition = (x, y) => {
    const container = globeMapRef.current;
    if (!container) return { x, y };
    const rect = container.getBoundingClientRect();
    const radius = getLensDiameter() / 2;
    return {
      x: Math.min(Math.max(x, radius), rect.width - radius),
      y: Math.min(Math.max(y, radius), rect.height - radius)
    };
  };

  const handleSearchLensDragStart = (event) => {
    if (!globeMap?.isSearchLens || !searchLensPosition) return;
    event.preventDefault();
    event.stopPropagation();
    const pointer = getPointerPosition(event);
    searchLensDragRef.current = {
      startX: pointer.clientX,
      startY: pointer.clientY,
      originX: searchLensPosition.x,
      originY: searchLensPosition.y
    };
    setSearchLensDragging(true);
  };

  useEffect(() => {
    if (!searchLensDragging) return;

    const handleMove = (event) => {
      if (!searchLensDragRef.current) return;
      event.preventDefault();
      const pointer = getPointerPosition(event);
      const next = clampLensPosition(
        searchLensDragRef.current.originX + pointer.clientX - searchLensDragRef.current.startX,
        searchLensDragRef.current.originY + pointer.clientY - searchLensDragRef.current.startY
      );
      setSearchLensPosition(next);
      searchLensPositionRef.current = next;
    };

    const handleEnd = () => {
      setSearchLensDragging(false);
      searchLensDragRef.current = null;
      scheduleSearchLensFetch(globeLeafletRef.current);
    };

    window.addEventListener('mousemove', handleMove);
    window.addEventListener('mouseup', handleEnd);
    window.addEventListener('touchmove', handleMove, { passive: false });
    window.addEventListener('touchend', handleEnd);
    window.addEventListener('touchcancel', handleEnd);

    return () => {
      window.removeEventListener('mousemove', handleMove);
      window.removeEventListener('mouseup', handleEnd);
      window.removeEventListener('touchmove', handleMove);
      window.removeEventListener('touchend', handleEnd);
      window.removeEventListener('touchcancel', handleEnd);
    };
  }, [searchLensDragging]);

  const persistFavoriteKeys = (favoriteKeys) => {
    try {
      writeSaveStorage(localFavoritesKey, [...favoriteKeys]);
    } catch (error) {
      // CRM saving remains authoritative if browser storage is unavailable.
    }
  };

const additionalFilterCount = [
    propertySubType, maxBedrooms, minSqft, maxSqft, stories, foundation,
    minYearBuilt, maxYearBuilt, schoolDistrict, listingKey, acreage,
    minBathrooms, maxBathrooms, hasFence, hasPool, showAgentListings,
    searchLensEnabled, priceSort, listingDateSort, ...communityFeatures
  ].filter(Boolean).length + Object.entries(advancedFilters).filter(([key, value]) =>
    key !== 'state' && value !== null && value !== undefined && value !== '' &&
    (!Array.isArray(value) || value.length > 0)
  ).length;
  useEffect(() => {
    if (!globeMap?.isSavedHomes) return;
    const list=globeMap.savedListId ? collections.find(row=>row.id===globeMap.savedListId) : null;
    const activeKeys=new Set((globeMap.savedListId ? list?.listingKeys || [] : [...likedProperties]).map(String));
    const properties=globeMap.properties.filter(property=>activeKeys.has(String(property.listing_key)));
    if(properties.length===globeMap.properties.length)return;
    if(!properties.length){setPropertyDetail(null);setGlobeMap(null);setMapView(true);window.history.replaceState(null,'','/search');return;}
    setGlobeMap(current=>({...current,properties}));
  },[likedProperties,collections]); // eslint-disable-line react-hooks/exhaustive-deps -- saved membership changes prune this view
  const handleViewSavedHomes = async (listKeys, listName, listId, editingListId) => {
    if (savedHomesLoading || (listKeys ? !listKeys.length : likedProperties.size === 0)) return;

    setSavedHomesLoading(true);
    setSavedHomesError('');
    const savedKeys = [...(listKeys || likedProperties)].filter(Boolean);
    let lookupFailed = false;

    try {
      const publicKeys = savedKeys.filter((key) => !String(key).startsWith('PRIVATE_'));
      const privateKeys = new Set(savedKeys.filter((key) => String(key).startsWith('PRIVATE_')).map(String));

      const publicProperties = await Promise.all(publicKeys.map(async (key) => {
        try {
          const response = await propertyFetch(`https://tophamtechbe.com/api/treas/idx/v1/retrieve-property-summary?listingKey=${encodeURIComponent(key)}`);
          if (!response.ok) {
            if (response.status >= 500 || response.status === 429) lookupFailed = true;
            return null;
          }
          const data = await response.json();
          const property = data.properties?.[0];
          return property ? { ...property, listing_key: property.listing_key || key } : null;
        } catch (error) {
          lookupFailed = true;
          return null;
        }
      }));

      let privateProperties = [];
      if (privateKeys.size > 0) {
        try {
          const response = await fetch(`https://tophamtechbe.com/api/treas/private/v1/listings?site_id=${SITE_CONFIG.SITE_ID}`, {
            headers: { 'x-api-key': 'treas-api-key-2025' }
          });
          if (!response.ok) {
            lookupFailed = true;
          } else {
            const data = await response.json();
            privateProperties = (data.listings || [])
              .map((listing) => ({
                ...listing,
                listing_key: `PRIVATE_${listing.id}`,
                current_price: listing.listing_type === 'sale' ? listing.price_sale : listing.price_lease_monthly,
                bedrooms_total: listing.beds,
                address: `${listing.address_line_1}, ${listing.city}, ${listing.state_province}`,
                isPrivate: true
              }))
              .filter((property) => privateKeys.has(String(property.listing_key)));
          }
        } catch (error) {
          lookupFailed = true;
        }
      }

      const savedProperties = [...publicProperties.filter(Boolean), ...privateProperties];
      if (savedProperties.length === 0) {
        if (lookupFailed || listKeys) {
          setSavedHomesError('Saved homes could not be loaded right now. Please try again.');
        } else {
          const emptyFavorites = new Set();
          setLikedProperties(emptyFavorites);
          persistFavoriteKeys(emptyFavorites);
        }
        return;
      }

      if (!lookupFailed && !listKeys) {
        const activeKeys = new Set(savedProperties.map((property) => property.listing_key));
        setLikedProperties(activeKeys);
        persistFavoriteKeys(activeKeys);
      }

      const mappableProperties = savedProperties.filter((property) => property.latitude && property.longitude);
      const center = mappableProperties.length > 0
        ? {
            lat: mappableProperties.reduce((sum, property) => sum + Number(property.latitude), 0) / mappableProperties.length,
            lon: mappableProperties.reduce((sum, property) => sum + Number(property.longitude), 0) / mappableProperties.length
          }
        : {
            lat: Number(SITE_CONFIG.LATITUDE) || 30.2672,
            lon: Number(SITE_CONFIG.LONGITUDE) || -97.7431
          };

      setListViewPage(0);
      setMapView(false);
      setShowAlertPill(false);
      alertTriggeredRef.current = true;
      setGlobeMap({
        center,
        location: listName || 'Saved homes',
        savedListId: listId || null,
        editingListId: editingListId || null,
        properties: savedProperties,
        searchFilters: {},
        isSavedHomes: true
      });
      window.history.replaceState(null, '', '/search?saved=true');
    } catch (error) {
      setSavedHomesError('Saved homes could not be loaded right now. Please try again.');
    } finally {
      setSavedHomesLoading(false);
    }
  };

  const handleGlobeMapSubmit = async e=>{e.preventDefault();if(isGlobeMapLoading||(!locationInput.trim()&&!listingKey&&!searchLensEnabled))return;setIsGlobeMapLoading(true);try{await fetchPropertiesForGlobe(locationInput.trim(),searchLensEnabled);}finally{setIsGlobeMapLoading(false);}};

  const loadMapPreview = (property) => {
    const key=property.listing_key;
    const cached=propertyImagesRef.current[key] || property.first_photo_url;
    if(cached || !key)return Promise.resolve(cached || null);
    if(!mapPreviewRequestsRef.current.has(key)) {
      const request=fetchPropertyImage(key).finally(()=>mapPreviewRequestsRef.current.delete(key));
      mapPreviewRequestsRef.current.set(key,request);
    }
    return mapPreviewRequestsRef.current.get(key);
  };

  const fetchPropertiesForGlobe = async (location, useSearchLens = false) => {
    // Detach result consumers before replacing the Leaflet instance. Otherwise
    // a filter change can read bounds from the map that cleanup just removed.
    setHybridMapInstance(null);
    const request=++initialMapRequestRef.current;initialMapAbortRef.current?.abort();const controller=new AbortController();initialMapAbortRef.current=controller;setMapStats({});setLensMapData(null);
    try {
      const queryParams = buildPropertySearchParams(location, !useSearchLens);
      applyManualFilters(queryParams);

      if (useSearchLens) {
        const displayLocation = location || getDefaultSearchLensLabel();
        const center = await geocodeSearchLocation(location);
        if(request!==initialMapRequestRef.current)return;
        const searchParams = searchFromQuery(queryParams);
        searchLensParamsRef.current = searchParams;
        setSearchLensSize(getDefaultSearchLensSize());
        setSearchLensProperties([]);
        setSearchLensResultCount(0);
        setSearchLensRadiusMiles(null);
        setMapView(true);
        setGlobeMap({ center, location: displayLocation, properties: [], isSearchLens: true, searchParams });

        const shareParams = searchQuery(searchParams);
        if (location) shareParams.set('q', location);
        shareParams.set('searchLens', 'true');
        window.history.replaceState(null, '', `/search?${shareParams.toString()}`);
        return;
      }

      const filters=searchFromQuery(queryParams);appliedSearchRef.current=filters;
      const shareParams=searchQuery(filters);if(location)shareParams.set('location',location);

      const [result,privateResult]=await Promise.all([
        loadPropertyMap({params:filters,zoom:4,signal:controller.signal}),
        loadPrivateMapRows({params:filters,siteId:SITE_CONFIG.SITE_ID,privateApiKey:'treas-api-key-2025',signal:controller.signal})]);
      if(request!==initialMapRequestRef.current)return;
      const point=result.map.features[0];
      const center=point?{lat:Number(point.latitude),lon:Number(point.longitude)}:{lat:Number(SITE_CONFIG.LATITUDE)||30,lon:Number(SITE_CONFIG.LONGITUDE)||-97};
      setMapView(true);setGlobeMap({center,location,properties:[],mapData:result.map,privateRows:privateResult.properties,privateUnavailable:privateResult.privateUnavailable,searchParams:filters});
      setMapStats({count:result.map.match_count,loading:false,error:''});setMapView(true);setListViewPage(0);
      if(new URLSearchParams(window.location.search).get('view') === 'map')shareParams.set('view','map');
      window.history.replaceState(window.history.state,'',`/search?${shareParams}`);
    } catch (error) {
      if(error.name==='AbortError'||request!==initialMapRequestRef.current)return;
      console.error('Error fetching properties for globe:', error);
      setManualSearchError(error.message || 'Unable to load property search.');
    }
  };

  useEffect(() => {
    let detachBoundedMap;
    let mapSizeObserver;
    if (globeMap && globeMapRef.current && mapView) {
      if (globeLeafletRef.current) {
        globeLeafletRef.current.remove();
      }

      const map = L.map(globeMapRef.current,{minZoom:1,maxZoom:20}).setView([globeMap.center.lat, globeMap.center.lon], globeMap.isSearchLens ? 14 : 12);

      addIllustratedBasemap(map);
      map.zoomControl.setPosition('bottomleft');
      if(globeMap.mapData){
        const pane=map.createPane('searchLensPreviewPane');pane.classList.add('search-lens-preview-pane');pane.style.zIndex='10050';pane.style.pointerEvents='none';
        detachBoundedMap=attachBoundedMap(map,{params:globeMap.searchParams,initialMap:globeMap.mapData,privateRows:globeMap.privateRows,getPreview:loadMapPreview,onProperty:p=>p.isPrivate?fetchPrivatePropertyDetail(p):fetchPropertyDetail(p.id,p),onStatus:value=>setMapStats(prev=>({...prev,...value}))});
      }else {
      const previewPane = map.createPane('searchLensPreviewPane');
      previewPane.classList.add('search-lens-preview-pane');
      previewPane.style.zIndex = '10050';
      previewPane.style.pointerEvents = 'none';
      if (globeMap.isSearchLens) {
        const size = map.getSize();
        const initialPosition = clampLensPosition(size.x / 2, isMobileViewport() ? size.y * 0.42 : size.y / 2);
        setSearchLensPosition(initialPosition);
        searchLensPositionRef.current = initialPosition;

        const updateLensResults = () => scheduleSearchLensFetch(map);
        const clearPreview = () => setSearchLensPreview(null);
        map.on('moveend', updateLensResults);
        map.on('zoomend', updateLensResults);
        map.on('movestart', clearPreview);
        map.on('zoomstart', clearPreview);
        setTimeout(() => scheduleSearchLensFetch(map, 0), 0);
      } else {
        renderPropertyMarkers(map, globeMap.properties || [], true);

        map.on('moveend', () => {
          if (map.getZoom() < 14) return;
          const bounds = map.getBounds();
          let fetched = 0;
          globeMap.properties.forEach(p => {
            if (fetched >= 25) return;
            if (p.latitude && p.longitude && p.listing_key && !p.isPrivate && !propertyImagesRef.current[p.listing_key]) {
              if (bounds.contains([p.latitude, p.longitude])) {
                fetchPropertyImage(p.listing_key);
                fetched++;
              }
            }
          });
        });

        map.fire('moveend');
      }

      }
      globeLeafletRef.current = map;
      setHybridMapInstance(map);
      mapSizeObserver = new ResizeObserver(() => map.invalidateSize({ pan: false }));
      mapSizeObserver.observe(globeMapRef.current);
    }

    return () => {
      mapSizeObserver?.disconnect();
      detachBoundedMap?.();lensAbortRef.current?.abort();
      clearTimeout(searchLensDebounceRef.current);
      if (globeLeafletRef.current) {
        globeLeafletRef.current.remove();
        globeLeafletRef.current = null;
        setHybridMapInstance(null);
        globeMarkersRef.current = null;
      }
    };
  }, [globeMap, mapView]);

  useEffect(()=>{if(!globeMap?.isSearchLens||!globeLeafletRef.current||!mapView)return;if(globeMarkersRef.current)globeLeafletRef.current.removeLayer(globeMarkersRef.current);globeMarkersRef.current=renderBoundedFeatures(globeLeafletRef.current,lensMapData?.features||[],{params:appliedSearchRef.current,getPreview:loadMapPreview,onProperty:p=>fetchPropertyDetail(p.id,p)});},[lensMapData,globeMap,mapView]);

  // Warm the detail cache for the map pills currently in view once the user has zoomed in
  // enough to see a small set (<= 7), so clicking any pill opens its modal snappily.
  useEffect(() => {
    if (!mapView || !globeMap) return;
    const visible = globeMap.isSearchLens ? searchLensProperties : globeMap.properties;
    if (Array.isArray(visible) && visible.length > 0 && visible.length <= 7) {
      visible.forEach((p) => prefetchPropertyDetail(p));
    }
  }, [searchLensProperties, globeMap, mapView]); // eslint-disable-line react-hooks/exhaustive-deps

  // Alert pill trigger: show after 4s or on first map interaction
  useEffect(() => {
    if (!globeMap || globeMap.isSearchLens || !globeLeafletRef.current || alertTriggeredRef.current) return;
    const trigger = () => {
      if (alertTriggeredRef.current) return;
      alertTriggeredRef.current = true;
      setShowAlertPill(true);
    };
    const timer = setTimeout(trigger, 4000);
    const map = globeLeafletRef.current;
    map.on('zoomend', trigger);
    return () => {
      clearTimeout(timer);
      if (map) map.off('zoomend', trigger);
    };
  }, [globeMap, mapView]);

  const handleServiceSelect = (service) => {
    setSelectedService(service);
    setSendButtonEnabled(true);
    setTimeout(scrollToBottom, 200);
  };

  const handleShowMoreProperties = async (messageIndex) => {
    const msg=messages[messageIndex];if(!msg||msg.loadingMore)return;
    if(msg.restartSearch){await fetchProperties(msg.searchFilters);return;}
    const nextPage=(msg.currentPage||0)+1;
    if(!msg.pageState||nextPage*itemsPerPage<msg.properties.length) {
      setMessages(prev=>prev.map((item,index)=>index===messageIndex?{...item,currentPage:nextPage}:item));return;
    }
    if(!msg.hasMore||moreRequestsRef.current.has(msg.searchId))return;
    const generation=chatGenerationRef.current;const controller=new AbortController();moreRequestsRef.current.set(msg.searchId,controller);
    const update=change=>setMessages(prev=>prev.map(item=>item.searchId===msg.searchId&&item.content==='properties'?{...item,...change}:item));
    update({loadingMore:true,pageError:''});
    try {
      const result=await loadPropertyPage({params:msg.searchFilters,pageState:msg.pageState,signal:controller.signal,pageSize:itemsPerPage,siteId:SITE_CONFIG.SITE_ID,queryOptions:{firstPhoto:true},privateApiKey:'treas-api-key-2025'});
      if(generation!==chatGenerationRef.current)return;
      const seen=new Set(msg.properties.map(p=>p.listing_key));
      update({properties:[...msg.properties,...result.properties.filter(p=>!seen.has(p.listing_key))],pageState:result.pageState,hasMore:result.hasMore,currentPage:nextPage,loadingMore:false});
    }catch(error){if(generation===chatGenerationRef.current&&error.name!=='AbortError')update({loadingMore:false,pageError:error.message,restartSearch:error.restartSearch});}
    finally{moreRequestsRef.current.delete(msg.searchId);}
  };

  const handleAiStaging = async (type) => {
    setStagingLoading(true);
    try {
      // Get random prompt for the selected type
      const promptResponse = await fetch(`https://tophamtechbeb.com/api/stage/v1/${type}-prompts/random`, {
        headers: { 'X-API-Key': 'treas-api-key-2025' }
      });

      if (!promptResponse.ok) {
        throw new Error('Failed to get staging prompt');
      }

      const promptData = await promptResponse.json();

      // Create form data with S3 URL
      const formData = new FormData();
      formData.append('image_url', enlargedImage);
      formData.append('design_prompt', promptData.prompt);

      // Call staging API
      const stagingResponse = await fetch('https://tophamtechbeb.com/api/stage/v1/stage-room', {
        method: 'POST',
        headers: { 'X-API-Key': 'treas-api-key-2025' },
        body: formData
      });

      if (!stagingResponse.ok) {
        throw new Error('Failed to stage room');
      }

      // Get staged image as blob and convert to URL
      const stagedBlob = await stagingResponse.blob();
      const imageUrl = URL.createObjectURL(stagedBlob);
      setStagingImage(imageUrl);
      setShowAiStaging(false);

    } catch (error) {
      console.error('Error staging room:', error);
      alert('Failed to stage room. Please try again.');
    } finally {
      setStagingLoading(false);
    }
  };

  const handleSellerLeadCaptureSubmit = async (e) => {
    e.preventDefault();
    setShowSellerLeadCapture(false);
    if (!isHoneypotSubmission(e.currentTarget)) await submitSellerInquiry(pendingSellerParams, email, name, phoneNumber);
    setPendingSellerParams(null);
    setChatLeadSubmitted(true);
    const botMessage = { type: 'bot', content: `Thanks ${name}! We've noted your property details and will be in touch shortly.` };
    setMessages(prev => [...prev, botMessage]);
    setTimeout(scrollToBottom, 200);
  };

  const handleBuyerLeadCaptureSubmit = async (e) => {
    e.preventDefault();
    const area = pendingBuyerParams?.city || zipCode;
    const postalCode = pendingBuyerParams?.zip || (zipCode.match(/^\d{5}$/) ? zipCode : '');
    const priceMax = pendingBuyerParams?.maxPrice || maxPrice;

    const leadParams = new URLSearchParams({
      name,
      email,
      phoneNumber,
      serviceReq: 'buying',
      siteId: SITE_CONFIG.SITE_ID,
    });
    if (area) leadParams.set('area', area);
    if (postalCode) leadParams.set('postalCode', postalCode);

    try {
      if (!isHoneypotSubmission(e.currentTarget)) await submitChatLead(new URL(`https://tophamtechbe.com/api/treas/idx/v1/chatleads?${leadParams}`).searchParams, { rememberContact: true });
    } catch (error) {
      console.error('Error submitting buyer lead:', error);
    }

    localStorage.setItem('leadInfo', JSON.stringify({ name, email, phone: phoneNumber }));
    setChatLeadSubmitted(true);

    const searchParams = {...(pendingBuyerParams || {})};
    if (!searchParams.city && !searchParams.zip && zipCode) searchParams.zip = zipCode;
    if (!searchParams.maxPrice && priceMax) searchParams.maxPrice = priceMax;
    setPendingBuyerParams(null);
    fetchProperties(searchParams);
    setShowProperties(true);

    setMessages(prev => [...prev, { type: 'bot', content: `Thanks ${name}! Here are properties matching your search.` }]);
    setTimeout(scrollToBottom, 200);
  };

  const handleSellingFormSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = isHoneypotSubmission(e.currentTarget) ? { ok: true } : await fetch(`https://tophamtechbe.com/api/treas/idx/v1/selling-details?name=${encodeURIComponent(name)}&email=${encodeURIComponent(email)}&phoneNumber=${encodeURIComponent(phoneNumber)}&address=${encodeURIComponent(propertyLocation)}&size=${encodeURIComponent(propertySize)}&condition=${encodeURIComponent(propertyCondition)}&timeline=${encodeURIComponent(sellingTimeline)}&siteId=${SITE_CONFIG.SITE_ID}`, {
        method: 'POST',
        headers: {
          'X-API-Key': 'treas-api-key-2025'
        }
      });

      if (response.ok) {
        console.log('Selling details submitted successfully');
      } else {
        console.error('Failed to submit selling details');
      }
    } catch (error) {
      console.error('Error submitting selling details:', error);
    }

    // Show completion message
    const botMessage = { type: 'bot', content: `Thank you! I have all the details about your property. Sandy Hopkins will contact you soon to discuss selling your ${propertySize} property in ${propertyLocation}.` };
    setMessages(prev => [...prev, botMessage]);
    setTimeout(scrollToBottom, 200);

    // Clear selling form but keep chat enabled
    setPropertyLocation('');
    setPropertySize('');
    setPropertyCondition('');
    setSellingTimeline('');
    // Don't set showThankYouMessage to false - keep send button enabled
  };

  const fetchPrivatePropertyDetail = async (listing) => {
    setPropertyDetailImages([]);
    setImagesLoading(true);

    const listingId = String(listing.listing_key).replace('PRIVATE_', '');

    // If listing data is incomplete (e.g. coming from a direct URL), fetch it first
    let fullListing = listing;
    if (!listing.current_price && !listing.address) {
      try {
        const detailResponse = await fetch(`https://tophamtechbe.com/api/treas/private/v1/listing/${listingId}?site_id=${SITE_CONFIG.SITE_ID}`, {
          headers: { 'x-api-key': 'treas-api-key-2025' }
        });
        if (detailResponse.ok) {
          const detailData = await detailResponse.json();
          const d = detailData.listing || detailData;
          fullListing = {
            ...d,
            listing_key: `PRIVATE_${d.id}`,
            current_price: d.listing_type === 'sale' ? d.price_sale : d.price_lease_monthly,
            bedrooms_total: d.beds,
            address: `${d.address_line_1}, ${d.city}, ${d.state_province}`,
            isPrivate: true
          };
        }
      } catch (error) {
        console.error('Error fetching private listing detail:', error);
      }
    }

    try {
      const mediaResponse = await fetch(`https://tophamtechbe.com/api/treas/media/private/v1/media/${SITE_CONFIG.SITE_ID}/${listingId}`, {
        headers: { 'x-api-key': 'treas-api-key-2025' }
      });

      if (mediaResponse.ok) {
        const mediaData = await mediaResponse.json();
        const sorted = (mediaData.media || []).sort((a, b) => a.order_hint - b.order_hint);
        setPropertyDetailImages(sorted.map(img => img.media_url || img.s3_link));
      }
    } catch (error) {
      console.error('Error fetching private property media:', error);
    } finally {
      setImagesLoading(false);
    }

    const address = fullListing.address || '';
    setPropertyDetail({
      ...fullListing,
      listing_key: fullListing.listing_key,
      current_price: fullListing.current_price,
      bedrooms_total: fullListing.bedrooms_total,
      created_at: fullListing.created_at,
      updated_at: fullListing.updated_at,
      location: {
        street_number: address.split(',')[0] || '',
        city: fullListing.city || '',
        state: fullListing.state_province || '',
        postal_code: fullListing.postal_code || ''
      },
      features: {
        public_remarks: fullListing.description || ''
      },
      isPrivate: true
    });
  };

  const warmedImageUrls = useRef(new Set());
  // Preload an existing summary photo without requesting unopened property details.
  const prefetchPropertyDetail = (property) => {
    if (navigator.connection?.saveData) return;
    warmImage(property?.first_photo_url);
  };

  const warmImage = (url) => {
    if (!url || warmedImageUrls.current.has(url)) return;
    warmedImageUrls.current.add(url);
    const im = new Image();
    im.src = url;
  };

  // Preload the current and next page summary photos.
  React.useEffect(() => {
    const conn = navigator.connection || {};
    if (conn.saveData) return;
    messages.forEach((msg) => {
      if (msg?.content !== 'properties' || !Array.isArray(msg.properties)) return;
      const page = msg.currentPage || 0;
      const visibleEnd = (page + 1) * itemsPerPage;
      const nextEnd = (page + 2) * itemsPerPage;
      msg.properties.slice(0, visibleEnd).forEach((p) => prefetchPropertyDetail(p));
      msg.properties.slice(visibleEnd, nextEnd).forEach((p) => {
        prefetchPropertyDetail(p);
        warmImage(p?.first_photo_url);
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messages, itemsPerPage]);

  const fetchPropertyDetail = async (propertyId, summaryData) => {
    const requestId = ++detailRequestRef.current;
    const cover = summaryData?.first_photo_url || summaryData?.image_url || summaryData?.photo_url;
    // Optimistic open: paint the modal INSTANTLY from the summary the clicked tile/pill
    // already has (price, address, and the first photo — already cached as the thumbnail),
    // so it doesn't wait on the (sometimes cold) detail round-trip. Enrich below.
    if (summaryData) {
      setPropertyDetail({
        ...summaryData,
        location: {
          street_number: summaryData.street_number,
          street_dir_prefix: summaryData.street_dir_prefix,
          street_suffix: summaryData.street_suffix,
          street_dir_suffix: summaryData.street_dir_suffix,
          unit_number: summaryData.unit_number,

          street_name: summaryData.street_name,
          city: summaryData.city,
          state: summaryData.state,
          postal_code: summaryData.postal_code
        },
        features: summaryData.features || {}
      });
      setPropertyDetailImages(cover ? [cover] : []);
      setImagesLoading(!cover);
    } else {
      setPropertyDetailImages([]);
      setImagesLoading(true);
    }

    try {
      const response = await propertyFetch(`https://tophamtechbe.com/api/treas/idx/v1/retrieve-property-data/${propertyId}`, {});
      if (requestId !== detailRequestRef.current) return;

      if (response.ok) {
        const data = await response.json();
        const property = data.properties[0];
        setPropertyDetail({
          ...property,
          created_at: property.created_at || summaryData?.created_at,
          updated_at: property.updated_at || summaryData?.updated_at
        });

        // Fetch all images for the property detail view
        if (property.listing_key) {
          fetchAllPropertyImages(property.listing_key, requestId, cover);
        }
      } else {
        console.error('Failed to fetch property details');
        setImagesLoading(false);
      }
    } catch (error) {
      console.error('Error fetching property details:', error);
      if (requestId === detailRequestRef.current) setImagesLoading(false);
    }
  };

  const fetchPropertyDetailByListingKey = async (listingKey) => {
    if (String(listingKey).startsWith('PRIVATE_')) {
      fetchPrivatePropertyDetail({ listing_key: listingKey });
      return;
    }
    try {
      const response = await propertyFetch(`https://tophamtechbe.com/api/treas/idx/v1/retrieve-property-summary?listingKey=${listingKey}`, {});

      if (response.ok) {
        const data = await response.json();
        const properties = data.properties || [];
        if (properties.length > 0) {
          const property = properties[0];
          // Fetch full details using property ID
          if (property.id) {
            fetchPropertyDetail(property.id, property);
          }
        } else {
          console.error('No property found for listing key:', listingKey);
          alert('Property not found. Please check the listing key.');
        }
      } else {
        console.error('Failed to fetch property by listing key');
        alert('Failed to load property. Please try again.');
      }
    } catch (error) {
      console.error('Error fetching property by listing key:', error);
      alert('Failed to load property. Please try again.');
    }
  };

  const fetchPropertyImage = async (listingKey) => {
    if (propertyImages[listingKey]) return propertyImages[listingKey];

    try {
      const imageUrl = propertyMediaUrls(await loadPropertyMedia(listingKey))[0];
      if (imageUrl) {
        setPropertyImages(prev => ({...prev, [listingKey]: imageUrl}));
        rememberPropertyPhoto(listingKey, imageUrl);
        return imageUrl;
      }
    } catch (error) {
      console.error('Error fetching property image:', error);
    }
    return null;
  };

  const fetchAllPropertyImages = async (listingKey, requestId = detailRequestRef.current, cover = '') => {
    try {
      const images = propertyMediaUrls(await loadPropertyMedia(listingKey));
      if (requestId !== detailRequestRef.current) return;
      if (images.length > 0) {
          const firstThree = images.slice(0, 3);
          setPropertyDetailImages(firstThree);
          setImagesLoading(false);
          rememberPropertyPhoto(listingKey, images[0]);
          if (images.length > 3) {
            setTimeout(() => {
              if (requestId === detailRequestRef.current) setPropertyDetailImages(images);
            }, 500);
          }
      } else {
        if (cover) setPropertyDetailImages([cover]);
        setImagesLoading(false);
      }
    } catch (error) {
      console.error('Error fetching all property images:', error);
      if (requestId === detailRequestRef.current) {
        if (cover) setPropertyDetailImages([cover]);
        setImagesLoading(false);
      }
    }
  };

  const closePropertyDetail = () => {
    detailRequestRef.current += 1;
    setPropertyDetail(null);
    setImagesLoading(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSecondMessage(true);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  const displayedMapProperties = globeMap?.isSearchLens ? searchLensProperties : (globeMap?.properties || []);

  if (isGlobeMap) {
    return (
      <>
        <style>{`
          @media (max-width: 1024px) {
            .list-view-image, .list-view-map { width: 120px !important; height: 90px !important; }
            .list-view-house-icon { font-size: 24px !important; }
          }
          @media (max-width: 768px) {
            .list-view-image, .list-view-map { width: 100px !important; height: 75px !important; }
            .list-view-house-icon { font-size: 20px !important; }
          }
        `}</style>
      <div className={`full-page-map-container map-first-search ${isDarkMode ? 'dark-mode' : ''}`}>
        <header className="map-search-header">
          <button type="button" className="map-search-home" onClick={onGlobeMapClose} aria-label="Return to home">← <span>Home</span></button>
          <form className="map-quick-filters" id="property-search-form" onChange={() => { sharedSearchRef.current = null; }} onSubmit={handleGlobeMapSubmit}>
            <div className="map-search-location">
              <label htmlFor="map-search-location">Location</label>
              <input id="map-search-location" type="text" value={locationInput} onChange={event => setLocationInput(event.target.value)} placeholder="City, state, or ZIP" aria-label="City, state, or ZIP code" required={!searchLensEnabled && !listingKey} />
            </div>
            <div className="map-common-filters" id="map-common-filters" hidden={!quickFiltersOpen}>
              <label>Property type<select aria-label="Property type" value={propertyType} onChange={event => setPropertyType(event.target.value)}>
                {['Residential', 'ResidentialLease', 'Land', 'ResidentialIncome', 'CommercialSale', 'CommercialLease', 'Farm'].map(value => <option key={value} value={value}>{value.replace(/([a-z])([A-Z])/g, '$1 $2')}</option>)}
              </select></label>
              <label>Min price<input type="number" min="0" aria-label="Minimum price" placeholder="Any" value={minPrice} onChange={event => setMinPrice(event.target.value)} /></label>
              <label>Max price<input type="number" min="0" aria-label="Maximum price" placeholder="Any" value={maxPrice} onChange={event => setMaxPrice(event.target.value)} /></label>
              <label>Beds<select aria-label="Minimum bedrooms" value={minBedrooms} onChange={event => setMinBedrooms(event.target.value)}><option value="">Any beds</option>{[1,2,3,4,5].map(value => <option key={value} value={value}>{value}+</option>)}</select></label>
              <label>Baths<select aria-label="Minimum bathrooms" value={minBathrooms} onChange={event => setMinBathrooms(event.target.value)}><option value="">Any baths</option>{[1,2,3,4,5].map(value => <option key={value} value={value}>{value}+</option>)}</select></label>
            </div>
            <div className="map-search-actions">
              <button type="submit" className="map-search-apply" disabled={isGlobeMapLoading || savedHomesLoading} aria-busy={isGlobeMapLoading}>{isGlobeMapLoading ? 'Searching…' : 'Search'}</button>
              <button type="button" className="map-saved-homes" disabled={savedHomesLoading || isGlobeMapLoading} onClick={() => handleViewSavedHomes()} aria-pressed={!!globeMap?.isSavedHomes}>Saved homes <span className="map-saved-count">{likedProperties.size}</span></button>
              <button type="button" className="map-filters-toggle" aria-expanded={quickFiltersOpen} aria-controls="map-common-filters" onClick={() => setQuickFiltersOpen(open => !open)}>Filters {quickFiltersOpen ? '−' : '+'}</button>
              <SearchFilterPanel busy={isGlobeMapLoading} count={additionalFilterCount} onApply={() => document.getElementById('property-search-form')?.requestSubmit()}><div className="filter-row"><select className="filter-select" value={maxBedrooms} onChange={e => setMaxBedrooms(e.target.value)}>
                    <option value="">Max Bedrooms</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5+</option>
                  </select></div>
                <label className={`search-lens-card ${searchLensEnabled ? 'active' : ''}`}>
                  <input type="checkbox" checked={searchLensEnabled} onChange={e => setSearchLensEnabled(e.target.checked)} />
                  <span className="search-lens-card-mark" aria-hidden="true">⌖</span>
                  <span className="search-lens-card-copy">
                    <span>Search Lens by Agent Winds</span>
                    <small>Explore the map with a movable lens and load only homes inside the circle.</small>
                  </span>
                </label>
                <div className="filter-row">
                  <select className="filter-select" value={propertySubType} onChange={e => setPropertySubType(e.target.value)}>
                    <option value="">Any home type</option>
                    <option value="SingleFamilyResidence">Single Family</option>
                    <option value="Apartment">Apartment</option>
                    <option value="Condominium">Condominium</option>
                    <option value="Townhouse">Townhouse</option>
                    <option value="Duplex">Duplex</option>
                    <option value="Ranch">Ranch</option>
                    <option value="Other">Other</option>
                  </select>
                  <select className="filter-select" value={priceSort || (listingDateSort === 'newold' ? 'listnewold' : listingDateSort === 'oldnew' ? 'listoldnew' : '')} onChange={e => {
                    const val = e.target.value;
                    if (val === 'lowhigh' || val === 'highlow') {
                      setPriceSort(val);
                      setListingDateSort('');
                    } else if (val === 'listnewold' || val === 'listoldnew') {
                      setListingDateSort(val === 'listnewold' ? 'newold' : 'oldnew');
                      setPriceSort('');
                    }
                  }}>
                    <option value="">Sort By</option>
                    <option value="lowhigh">Price: Low to High</option>
                    <option value="highlow">Price: High to Low</option>
                    <option value="listnewold">Listed Date: Newest</option>
                    <option value="listoldnew">Listed Date: Oldest</option>
                  </select>
                </div>
                <div className="filter-row">
                  <input type="number" placeholder="Min Sq Ft" value={minSqft} onChange={e => setMinSqft(e.target.value)} className="filter-select" />
                  <input type="number" placeholder="Max Sq Ft" value={maxSqft} onChange={e => setMaxSqft(e.target.value)} className="filter-select" />
                </div>
                <div className="filter-row">
                  <input type="number" placeholder="Stories" value={stories} onChange={e => setStories(e.target.value)} className="filter-select" />
                  <select className="filter-select" value={foundation} onChange={e => setFoundation(e.target.value)}>
                    <option value="">Foundation Type</option>
                    <option value="CrawlSpace">Crawl Space</option>
                    <option value="Slab">Slab</option>
                  </select>
                </div>
                <div className="filter-row filter-year-row">
                  <input type="number" placeholder="Min Year Built" value={minYearBuilt} onChange={e => setMinYearBuilt(e.target.value)} className="filter-select" />
                  <input type="number" placeholder="Max Year Built" value={maxYearBuilt} onChange={e => setMaxYearBuilt(e.target.value)} className="filter-select" />
                </div>
                <div className="filter-row">
                  <input type="text" placeholder="School District" value={schoolDistrict} onChange={e => setSchoolDistrict(e.target.value)} className="filter-select" />
                  <input type="text" placeholder="Listing Key" value={listingKey} onChange={e => setListingKey(e.target.value)} className="filter-select" />
                </div>
                <div className="filter-row">
                  <select className="filter-select" value={acreage} onChange={e => setAcreage(e.target.value)}>
                    <option value="">Acreage</option>
                    <option value="<5">&lt; 5 Acres</option>
                    <option value="5to10">5 to 10 Acres</option>
                    <option value="10+">10+ Acres</option>
                  </select>
                  <select className="filter-select" multiple value={communityFeatures} onChange={e => setCommunityFeatures(Array.from(e.target.selectedOptions, o => o.value))}>
                    <option value="greenbelt">Greenbelt</option>
                    <option value="hill">Hill Country</option>
                    <option value="golf">Golf Course</option>
                    <option value="downtown">Downtown</option>
                    <option value="water">Water</option>
                  </select>
                </div>
                <RobustSearchControls expanded filters={advancedFilters} onChange={next => {sharedSearchRef.current=null;setAdvancedFilters(next);}} scope={{state:advancedFilters.state || SITE_CONFIG.SEARCH_STATES || SITE_CONFIG.STATE,propertyType}} />
                <div className="filter-row">
                  <input type="number" placeholder="Min Bathrooms" value={minBathrooms} onChange={e => setMinBathrooms(e.target.value)} className="filter-select" />
                  <input type="number" placeholder="Max Bathrooms" value={maxBathrooms} onChange={e => setMaxBathrooms(e.target.value)} className="filter-select" />
                </div>
                <div className="filter-row filter-toggle-row">
                  <label className="agent-toggle">
                    <input type="checkbox" checked={showAgentListings} onChange={e => setShowAgentListings(e.target.checked)} />
                              Show only {SITE_CONFIG.AGENT.NAME}'s listings
                            </label>
                  <label className="agent-toggle">
                    <input type="checkbox" checked={hasFence} onChange={e => setHasFence(e.target.checked)} />
                              Has Fencing
                            </label>
                  <label className="agent-toggle">
                    <input type="checkbox" checked={hasPool} onChange={e => setHasPool(e.target.checked)} />
                              Pool
                            </label>
                </div></SearchFilterPanel>
            </div>
          </form>
        </header>
        {manualSearchError && <p className="map-search-error" role="alert">{manualSearchError} Adjust your filters and try again.</p>}
        {savedHomesError && <p className="map-search-error" role="alert">{savedHomesError}</p>}
        {!globeMap ? <div className="map-search-loading" role="status">{isGlobeMapLoading || initialCityLoading ? 'Finding homes on the map…' : 'Choose a location and select Search to see homes.'}</div> : (
          <div className={[`full-page-leaflet-container ${globeMap.isSearchLens ? 'search-lens-mode' : ''}`,mapView && hybridView ? 'hybrid-map-view' : '',mapTrayExpanded ? 'map-tray-expanded' : ''].join(' ')}>
<div className="map-workspace">


            {mapView && globeMap.mapData && (mapStats.loading||mapStats.error||globeMap.privateUnavailable) && <p className="bounded-map-status" role={mapStats.error?'alert':'status'}>{mapStats.error||(mapStats.loading?'Updating visible homes…':'Private listings are currently unavailable.')}</p>}
            {mapView && <div ref={globeMapRef} className="full-page-leaflet-map"></div>}
            {mapView && globeMap.isSearchLens && searchLensPosition && (
              <>
                <div className="search-lens-overlay" aria-hidden="true">
                  <div
                    className={`search-lens-circle ${searchLensDragging ? 'dragging' : ''}`}
                    style={{
                      left: `${searchLensPosition.x}px`,
                      top: `${searchLensPosition.y}px`,
                      width: `${getLensDiameter()}px`,
                      height: `${getLensDiameter()}px`
                    }}
                  />
                  <button
                    type="button"
                    className={`search-lens-handle ${searchLensDragging ? 'dragging' : ''}`}
                    style={{
                      left: `${searchLensPosition.x}px`,
                      top: `${searchLensPosition.y - (getLensDiameter() / 2) - 12}px`
                    }}
                    onMouseDown={handleSearchLensDragStart}
                    onTouchStart={handleSearchLensDragStart}
                    aria-label="Move Search Lens"
                  >
                    Move Lens
                  </button>
                </div>
                {searchLensPreview && (
                  <div
                    className="search-lens-hover-preview"
                    style={{
                      left: `${searchLensPreview.x}px`,
                      top: `${searchLensPreview.y - 14}px`
                    }}
                  >
                    <img src={searchLensPreview.imageUrl} alt="" />
                  </div>
                )}
                <div className="search-lens-panel">
                  <div className="search-lens-title">Search Lens by Agent Winds</div>
                  <div className="search-lens-meta">
                    {searchLensLoading
                      ? 'Searching lens...'
                      : `${searchLensResultCount} ${searchLensResultCount === 1 ? 'home' : 'homes'} in lens`}
                    {searchLensRadiusMiles && (
                      <span>{searchLensRadiusMiles.toFixed(2)} mi radius</span>
                    )}
                  </div>
                  <div className="search-lens-size-control" aria-label="Search Lens size">
                    {['small', 'medium', 'large'].map(size => (
                      <button
                        key={size}
                        type="button"
                        className={searchLensSize === size ? 'active' : ''}
                        onClick={() => handleSearchLensSizeChange(size)}
                      >
                        {size.charAt(0).toUpperCase() + size.slice(1)}
                      </button>
                    ))}
                  </div>
                  <div className="search-lens-filter-control">
                    <label>
                      <span>
                        Max Price
                        <strong>{maxPrice ? `$${Number(maxPrice).toLocaleString()}` : 'Any'}</strong>
                      </span>
                      <input
                        type="range"
                        min="0"
                        max="2000000"
                        step="25000"
                        value={maxPrice || '0'}
                        onChange={(e) => handleSearchLensMaxPriceChange(e.target.value)}
                      />
                    </label>
                    <label>
                      <span>
                        Rooms
                        <strong>{minBedrooms ? `${minBedrooms}+` : 'Any'}</strong>
                      </span>
                      <input
                        type="range"
                        min="0"
                        max="6"
                        step="1"
                        value={minBedrooms || '0'}
                        onChange={(e) => handleSearchLensBedroomsChange(e.target.value)}
                      />
                    </label>
                  </div>
                  <button
                    type="button"
                    className="search-lens-back-btn"
                    onClick={() => {
                      setGlobeMap(null);
                      setSearchLensProperties([]);
                      setSearchLensLoading(false);
                      setSearchLensResultCount(0);
                      setSearchLensRadiusMiles(null);
                      setSearchLensPosition(null);
                      setSearchLensSize(getDefaultSearchLensSize());
                      setSearchLensPreview(null);
                      searchLensParamsRef.current = null;
                      clearTimeout(searchLensDebounceRef.current);
                    }}
                  >
                    Back to Filters
                  </button>
                </div>
              </>
            )}
            {!mapView && (
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                overflowY: 'auto',
                WebkitOverflowScrolling: 'touch',
                padding: '80px 20px 100px 20px',
                background: isDarkMode ? 'rgb(15, 23, 42)' : '#f3f3f3',
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}>
                  {globeMap.editingListId && <section className="saved-list-edit-heading"><h3>Add homes to {collections.find(row=>row.id===globeMap.editingListId)?.name || 'your list'}</h3><p>Check the saved homes you want in this list. Your choices are saved immediately.</p><button type="button" onClick={()=>{const list=collections.find(row=>row.id===globeMap.editingListId);if(list?.listingKeys.length)handleViewSavedHomes(list.listingKeys,list.name,list.id);else setGlobeMap(null);}}>Done</button></section>}{displayedMapProperties && displayedMapProperties.slice(listViewPage * 7, (listViewPage + 1) * 7).map((property, index) => {
                  return (
                    <div
                      key={index}
                      onClick={() => property.isPrivate ? fetchPrivatePropertyDetail(property) : fetchPropertyDetail(property.id, property)}
                      className={`list-view-card ${globeMap.isSavedHomes ? 'saved-home-card' : ''}`}
                      style={{
                        padding: '20px',
                        marginBottom: '16px',
                        border: 'none',
                        borderLeft: '3px solid transparent',
                        cursor: 'pointer',
                        background: 'white',
                        display: 'flex',
                        gap: '20px',
                        transition: 'all 0.2s ease',
                        boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                        borderRadius: '4px',
                        maxWidth: '900px',
                        width: '100%'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.borderLeftColor = '#0176d3';
                        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                        prefetchPropertyDetail(property);
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.borderLeftColor = 'transparent';
                        e.currentTarget.style.boxShadow = '0 1px 2px rgba(0,0,0,0.05)';
                      }}
                    >
                      <script type="application/ld+json">
                        {JSON.stringify({
                          "@context": "https://schema.org",
                          "@type": "RealEstateProperty",
                          "name": formatPropertyAddress(property),
                          "address": {
                            "@type": "PostalAddress",
                            "streetAddress": formatStreetAddress(property),
                            "addressLocality": property.city,
                            "addressRegion": property.state,
                            "postalCode": property.postal_code
                          },
                          "price": property.current_price || property.price,
                          "priceCurrency": "USD",
                          "numberOfRooms": property.bedrooms_total,
                          "floorSize": {
                            "@type": "QuantitativeValue",
                            "value": property.living_area,
                            "unitCode": "SQF"
                          },
                          "propertyType": property.property_type,
                          "image": property.first_photo_url || property.image_url || property.photo_url,
                          "url": `${window.location.origin}/listing/${property.listing_key}`
                        })}
                      </script>
                      <PropertyThumbnail
                        listingKey={property.listing_key}
                        src={property.first_photo_url || property.image_url || property.photo_url}
                        alt={`Main exterior photo of property at ${property.address || property.street_address}`}
                        className="list-view-image"
                        style={{width: '200px', height: '150px', objectFit: 'cover', borderRadius: '4px', flexShrink: 0, border: '1px solid #e5e5e5'}}
                      />
                      <div style={{flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                        <div style={{fontWeight: '600', fontSize: '24px', color: '#0176d3', marginBottom: '8px'}}>
                          ${property.list_price?.toLocaleString() || property.current_price?.toLocaleString() || property.price}
                        </div>
                        <div style={{fontSize: '16px', color: '#ffffff', marginBottom: '6px', fontWeight: '400'}}>
                          {formatPropertyAddress(property)}
                        </div>
                        {property.property_type && (
                          <div style={{fontSize: '14px', color: '#706e6b', marginBottom: '4px'}}>
                            {property.property_type}
                          </div>
                        )}
                        {property.bedrooms_total && (
                          <div style={{fontSize: '14px', color: '#706e6b'}}>
                            🛏️ {property.bedrooms_total} bed
                          </div>
                        )}
                      </div>
                      {property.latitude && property.longitude && (
                        <div
                          className="list-view-map"
                          style={{position: 'relative', width: '200px', height: '150px', flexShrink: 0, cursor: 'pointer', borderRadius: '4px', overflow: 'hidden', border: '1px solid #e5e5e5'}}
                          onClick={(e) => {
                            e.stopPropagation();
                            setExpandedMap({lat: property.latitude, lon: property.longitude, address: formatPropertyAddress(property)});
                          }}
                        >
                <img
                  src={`https://tile.openstreetmap.org/15/${getTileCoords(property.latitude, property.longitude, 15).x}/${getTileCoords(property.latitude, property.longitude, 15).y}.png`}
                  alt={`Map location for property at ${property.address || property.street_address}`}
                  style={{width: '100%', height: '100%', objectFit: 'cover'}}
                />
                          <div className="list-view-house-icon" style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', fontSize: '28px', filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))'}}>🏠</div>
                        </div>
                      )}
                    {globeMap.isSavedHomes && (globeMap.editingListId ? <PropertyListMembership listingKey={property.listing_key} listId={globeMap.editingListId}/> : <PropertyListPicker listingKey={property.listing_key}/>)}</div>
                  );
                })}
                <div style={{display: 'flex', justifyContent: 'center', gap: '12px', marginTop: '24px', paddingBottom: '20px', alignItems: 'center'}}>
                  {listViewPage > 0 && (
                    <button
                      onClick={() => setListViewPage(listViewPage - 1)}
                      style={{
                        padding: '8px 16px',
                        background: 'white',
                        color: '#0176d3',
                        border: '1px solid #dddbda',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '13px',
                        fontWeight: '600',
                        transition: 'all 0.2s ease',
                        boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#f3f3f3';
                        e.currentTarget.style.borderColor = '#0176d3';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'white';
                        e.currentTarget.style.borderColor = '#dddbda';
                      }}
                    >
                      ← Previous
                    </button>
                  )}
                  <span style={{padding: '8px 16px', fontSize: '13px', color: '#3e3e3c', fontWeight: '400'}}>
                    Page {listViewPage + 1} of {Math.ceil(displayedMapProperties.length / 7)}
                  </span>
                  {(listViewPage + 1) * 7 < displayedMapProperties.length && (
                    <button
                      onClick={() => setListViewPage(listViewPage + 1)}
                      style={{
                        padding: '8px 16px',
                        background: 'white',
                        color: '#0176d3',
                        border: '1px solid #dddbda',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '13px',
                        fontWeight: '600',
                        transition: 'all 0.2s ease',
                        boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#f3f3f3';
                        e.currentTarget.style.borderColor = '#0176d3';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'white';
                        e.currentTarget.style.borderColor = '#dddbda';
                      }}
                    >
                      Next →
                    </button>
                  )}
                </div>
              </div>
            )}
            <div className="map-toolbar map-toolbar--compact"><div className="map-info">
 <div className="map-view-switcher" role="group" aria-label="Property view">
 <button type="button" className="map-view-option" aria-pressed={!hybridView} onClick={() => {setMapView(true);setMapTrayExpanded(false);setHybridView(false);setActiveMapTool(null);}}>Map</button>
 <button type="button" className="map-view-option map-view-toggle" aria-pressed={hybridView} onClick={() => {setMapView(true);setMapTrayExpanded(false);setHybridView(true);setActiveMapTool(null);}}>Hybrid</button>
 <button type="button" className="map-view-option map-list-option" onClick={()=>{const filters={...appliedSearchRef.current,...(globeMap.mapData?mapStats.bounds:{})};navigate(`/properties/list?${searchQuery(filters)}`,{state:{user,searchFilters:filters,...(globeMap.isSavedHomes?{properties:globeMap.properties,isSavedHomes:true,savedMap:globeMap}:{})}});}}>List</button>
 </div><div className="map-tools-row"><div className="map-result-count" aria-live="polite">{globeMap.mapData?`${mapStats.count??globeMap.mapData.match_count} homes in view`:globeMap.isSearchLens?`${searchLensResultCount} properties in Search Lens`:globeMap.location}</div><div className="map-tools-actions">{showAlertPill && mapView && !manualSearchError && (
              <AlertPill compact compactOpen={activeMapTool === 'alerts'} onCompactOpenChange={setAlertsOpen}
                city={globeMap.location}
                pillState={alertPillState}
                setPillState={setAlertPillState}
                searchFilters={appliedSearchRef.current}
                existingUser={{
                  name: user?.username || name || '',
                  email: user?.email || email || '',
                  phoneNumber: user?.phoneNumber || phoneNumber || '',
                  postalCode: zipCode || '',
                }}
                onClose={() => setShowAlertPill(false)}
              />
            )}</div></div>
 </div></div>
          </div>
<MapPlaceLayers compact compactOpen={activeMapTool === 'places'} onCompactOpenChange={setPlacesOpen} map={mapView && !propertyDetail && !expandedMap ? hybridMapInstance : null} />
{mapView && hybridView && !propertyDetail && <MapPropertyGrid favorites={favorites} onSave={property=>toggleFavorite(property,user)} map={hybridMapInstance} trayExpanded={mapTrayExpanded} onTrayToggle={()=>setMapTrayExpanded(value=>!value)} params={globeMap.searchParams || globeMap.searchFilters || {}} properties={!globeMap.mapData ? globeMap.properties : undefined} onProperty={property=>property.isPrivate?fetchPrivatePropertyDetail(property):fetchPropertyDetail(property.id,property)} />}
</div>
        )}
        <PropertyDetailModal
          propertyDetail={propertyDetail}
          propertyDetailImages={propertyDetailImages}
          imagesLoading={imagesLoading}
          onClose={() => {
            if (directListingKey) {
              closePropertyDetail();
              navigate('/');
            } else {
              closePropertyDetail();
            }
          }}
          user={user}
          isAdmin={isAdmin}
          likedProperties={likedProperties}
          setLikedProperties={setLikedProperties}
          senderEmail={senderEmail}
          senderPassword={senderPassword}
          onLeadCaptured={({ name: n, email: e, phone: p }) => {
            setName(n);
            setEmail(e);
            setPhoneNumber(p);
          }}
        />
        {expandedMap && isGlobeMap && (
          <div className="expanded-map-modal" onClick={() => setExpandedMap(null)}>
            <div className="expanded-map" onClick={(e) => e.stopPropagation()}>
              <button className="close-expanded-map" onClick={() => setExpandedMap(null)}>
                ×
              </button>
              <div ref={mapRef} className="leaflet-map"></div>
              <MapPlaceLayers map={placesExpandedMapInstance} />
            </div>
          </div>
        )}
        <div className="mobile-map-disclosure" style={{background: 'rgba(0,0,0,0.85)', padding: '6px 12px', display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', position: 'absolute', bottom: 0, left: 0, right: 0, zIndex: 1000}}>
          <img src={SITE_CONFIG.MLS.LOGO_URL} alt={SITE_CONFIG.MLS.SHORT_NAME} style={{height: '20px', objectFit: 'contain'}} />
          <span style={{fontSize: '10px', color: '#ccc', flex: 1}}>{SITE_CONFIG.MLS.DISCLAIMER} | Brokerage License: {SITE_CONFIG.AGENT.BROKERAGE_LICENSE} | Agent License: {SITE_CONFIG.AGENT.LICENSE}</span>
        </div>
      </div>
      </>
    );
  }

  const latestMobilePropertyIndex = messages.reduce((last, message, index) => message.content === 'properties' ? index : last, -1);
  const latestMobilePropertyMessage = messages[latestMobilePropertyIndex];

  return (
    <div className="action-buttons-container" role="region" aria-label="Real estate chat assistant">
      {window.location.pathname === '/chat' && latestMobilePropertyMessage?.properties?.length > 0 && (
        <LegacyMobilePropertyBrowser message={latestMobilePropertyMessage} pageSize={itemsPerPage}
          onMore={() => handleShowMoreProperties(latestMobilePropertyIndex)}
          onRestart={() => fetchProperties(latestMobilePropertyMessage.searchFilters)}
          onOpen={property => property.isPrivate ? fetchPrivatePropertyDetail(property) : fetchPropertyDetail(property.id, property)}
          onSave={property => toggleFavorite(property, user)} favorites={likedProperties} images={propertyImages}
          paused={isPropertySearching || Boolean(propertyDetail)} />
      )}
      <div className={`chat-box ${isDarkMode ? 'dark-mode' : ''}`} role="complementary">
        {(isThinking || isPropertySearching) && <p role="status">{isPropertySearching ? 'Searching live listings…' : 'Thinking…'}</p>}
        <div className="chat-messages" ref={messagesContainerRef} role="log" aria-live="polite" aria-label="Chat conversation history">
          <div className="message bot-message welcome-message">
            <div className="agent-profile">
              <div className="agent-avatar">
                <img src="https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/logos/raw-s-hopkins.png" alt={`${SITE_CONFIG.AGENT.NAME} - Your Real Estate Agent`} className="agent-avatar-img" />
              </div>
              <div className="agent-message">
                Selling your property? Get a free home evaluation, just click the Selling button below
              </div>
            </div>
            <div className="welcome-text">
              Hi! I'm here to help you find your perfect home. I can show you properties, help you sign in, register, or connect you directly with Sandy for a personal consultation.
              <br /><br />
              <strong className="cta-text">How can I help you today?</strong>
            </div>
            <div className="service-buttons">
              <div className="button-row">
                <button
                  className="service-button gold-outline"
                  onClick={() => handleServiceSelect('buying')}
                  aria-label="Select buying service to search for properties to purchase"
                >
                  Buying
                </button>
                <button
                  className="service-button gold-outline"
                  onClick={() => handleServiceSelect('selling')}
                  aria-label="Select selling service to list your property for sale"
                >
                  Selling
                </button>
              </div>
              <div className="button-row">
                <button
                  className="service-button"
                  onClick={() => handleServiceSelect('lease')}
                  aria-label="Select lease service to find rental properties"
                >
                  Lease
                </button>
                <button
                  className="service-button"
                  onClick={() => { setShowLogin(true); setSendButtonEnabled(true); }}
                  aria-label="Sign in to your account to access saved properties and preferences"
                >
                  Sign In
                </button>
                <button
                  className="service-button"
                  onClick={() => { setShowRegistration(true); setSendButtonEnabled(true); }}
                  aria-label="Register for a new account to save properties and get personalized recommendations"
                >
                  Register
                </button>
              </div>
            </div>
          </div>

          {selectedService && (
            <div className="message bot-message">
              <h3 className="form-title">Perfect! Let's get your information</h3>
              <p className="form-subtitle">Tell us a bit about yourself so we can better assist with your {selectedService === 'lease' ? 'leasing' : selectedService} needs</p>
              <form className="chat-form" onSubmit={handleFormSubmit}>
                <HoneypotField />
                <input
                  type="text"
                  placeholder="Enter your zip code"
                  value={zipCode}
                  onChange={(e) => setZipCode(e.target.value)}
                  className="form-input"
                  required
                />
                <input
                  type="text"
                  placeholder="Enter your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="form-input"
                  required
                />
                <input
                  type="tel"
                  placeholder="Enter your phone number"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  className="form-input"
                  required
                />
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="form-input"
                  required
                />
                <button type="submit" className="form-submit cta-button" aria-label="Submit your information to get started with property search">Get Started</button>
              </form>
            </div>
          )}
          {showThankYouMessage && (
            <div className="message bot-message">
              {selectedService === 'buying' ? (
                <div>
                  <p>Thank you, {name}! Since you're looking to buy, would you like to see some properties for sale in {zipCode}?</p>
                  <div className="service-buttons">
                    <button className="service-button" onClick={() => { console.log('Fetching properties for zip:', zipCode); fetchProperties({zip: zipCode}); setShowProperties(true); }}>Yes, Show Properties</button>
                    <button className="service-button" onClick={() => setShowThankYouMessage(false)}>Not Right Now</button>
                  </div>
                </div>
              ) : selectedService === 'selling' ? (
                <div>
                  <p>Thank you, {name}! Let's get some details about your property to help with the selling process.</p>
                  <form className="chat-form" onSubmit={handleSellingFormSubmit}>
                <HoneypotField />
                    <input
                      type="text"
                      placeholder="Property location/address"
                      value={propertyLocation}
                      onChange={(e) => setPropertyLocation(e.target.value)}
                      className="form-input"
                      required
                    />
                    <input
                      type="text"
                      placeholder="Property size (e.g., 3 bed, 2 bath)"
                      value={propertySize}
                      onChange={(e) => setPropertySize(e.target.value)}
                      className="form-input"
                      required
                    />
                    <select
                      value={propertyCondition}
                      onChange={(e) => setPropertyCondition(e.target.value)}
                      className="form-input"
                      required
                    >
                      <option value="">Select property condition</option>
                      <option value="excellent">Excellent</option>
                      <option value="good">Good</option>
                      <option value="fair">Fair</option>
                      <option value="needs-work">Needs Work</option>
                    </select>
                    <select
                      value={sellingTimeline}
                      onChange={(e) => setSellingTimeline(e.target.value)}
                      className="form-input"
                      required
                    >
                      <option value="">Select timeline</option>
                      <option value="asap">ASAP</option>
                      <option value="1-3-months">1-3 months</option>
                      <option value="3-6-months">3-6 months</option>
                      <option value="6-months-plus">6+ months</option>
                    </select>
                    <button type="submit" className="form-submit cta-button">Submit Property Details</button>
                  </form>
                </div>
              ) : selectedService === 'lease' ? (
                <p>Thank you, {name}! How else can I help you today?</p>
              ) : (
                <p>Thank you, {name}! How else can I help you today?</p>
              )}
            </div>
          )}
          {messages.map((message, index) => (
            <div key={index} className={`message ${message.type === 'user' ? 'user-message' : 'bot-message'} ${message.content === 'properties' && message.properties?.length > 0 ? 'legacy-property-message' : ''}`}>
              {message.content === 'properties' ? (
                <div>
                  {message.properties.length > 0
                    ? `Found ${message.properties.length} properties:`
                    : message.privateUnavailable
                      ? 'No MLS properties matched this search.'
                      : 'No properties matched this search. Try changing a feature, budget, or location.'}
                  {message.privateUnavailable && (
                    <p role="status">Private listings could not be loaded. These results include MLS listings only.</p>
                  )}
                  {message.properties.length > itemsPerPage && (
                    <div style={{fontSize: '14px', color: '#666', marginBottom: '10px'}}>
                      Showing {Math.min(((message.currentPage || 0) + 1) * itemsPerPage, message.properties.length)} of {message.properties.length} properties
                    </div>
                  )}
                  <div className="properties-list">
                    {message.properties.slice(0, ((message.currentPage || 0) + 1) * itemsPerPage).map((property, propIndex) => (
                      <div key={propIndex} className="property-item" role="article" aria-label={`Property listing: ${property.address || property.street_address || 'Property'} - $${property.current_price || property.price}`}>
                        <script type="application/ld+json">
                          {JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "RealEstateProperty",
                            "name": formatPropertyAddress(property),
                            "address": {
                              "@type": "PostalAddress",
                              "streetAddress": formatStreetAddress(property),
                              "addressLocality": property.city,
                              "addressRegion": property.state,
                              "postalCode": property.postal_code
                            },
                            "price": property.current_price || property.price,
                            "priceCurrency": "USD",
                            "numberOfRooms": property.bedrooms_total || property.bedrooms,
                            "propertyType": property.property_type,
                            "url": `${window.location.origin}/listing/${property.listing_key}`
                          })}
                        </script>
                        <div className="property-map">
                          <div
                            className="mini-map clickable"
                            onClick={() => setExpandedMap({...getPropertyCoords(property), address: property.address || `Property ${property.id}`})}
                          >
                            <img
                              src={`https://tile.openstreetmap.org/15/${getTileCoords(getPropertyCoords(property).lat, getPropertyCoords(property).lon, 15).x}/${getTileCoords(getPropertyCoords(property).lat, getPropertyCoords(property).lon, 15).y}.png`}
                              alt={`Map tile showing location of ${property.address || 'property'}`}
                              className="map-tile"
                              onError={(e) => {
                                e.target.style.display = 'none';
                                if (e.target.nextSibling) e.target.nextSibling.style.display = 'block';
                              }}
                            />
                            <div className="house-icon">🏠</div>
                            <div className="map-fallback" style={{display: 'none'}}>
                              <div className="map-dot"></div>
                            </div>
                          </div>
                        </div>
                        <div className="property-image">
                          <div
                            className="property-photo clickable"
                            onClick={() => property.isPrivate ? fetchPrivatePropertyDetail(property) : fetchPropertyDetail(property.id, property)}
                            style={{cursor: 'pointer'}}
                          >
                            <PropertyThumbnail listingKey={property.listing_key}
                                src={propertyImages[property.listing_key] || property.first_photo_url || property.image_url || property.photo_url}
                                alt={`Property photo for ${property.address || property.street_address || 'listing'}`}
                                className="property-thumbnail"
                              />
                          </div>
                        </div>
                        <div className="property-details">
                          <div className="property-address">{formatPropertyAddress(property) || `Property ID: ${property.id}`}</div>
                          <div className="property-price">${property.current_price || property.price}</div>
                          <div className="property-specs">
                            {(property.bedrooms_total || property.bedrooms) && `${property.bedrooms_total || property.bedrooms} bed`}
                            {property.property_type && ` • ${property.property_type}`}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  {message.pageError && <p role="alert">{message.pageError}</p>}
                  {(message.hasMore || message.properties.length > ((message.currentPage || 0) + 1) * itemsPerPage) && (
                    <div style={{textAlign: 'center', marginTop: '15px'}}>
                      <button
                        className="service-button"
                        disabled={message.loadingMore}
                        onClick={() => handleShowMoreProperties(index)}
                        style={{background: '#007bff', color: 'white'}}
                      >
                        {message.loadingMore ? 'Loading…' : message.restartSearch ? 'Restart search' : 'Show more homes'}
                      </button>
                    </div>
                  )}
                </div>
              ) : message.content === 'agent_contact_capture' ? (
                <div>
                  <p>Sure! Just share your contact details and the agent will reach out:</p>
                  <form className="chat-form" onSubmit={async (e) => {
                    e.preventDefault();
                    setName(leadName);
                    setPhoneNumber(leadPhone);
                    if (!isHoneypotSubmission(e.currentTarget)) {
                      localStorage.setItem('leadInfo', JSON.stringify({ name: leadName, email: leadEmail, phone: leadPhone }));
                      await sendAgentSMS(leadName, leadPhone);
                    }
                    setMessages(prev => [...prev, { type: 'bot', content: `Got it, ${leadName}! The agent will contact you at ${leadPhone} shortly.` }]);
                    setLeadName(''); setLeadPhone(''); setLeadEmail('');
                  }}>
                    <HoneypotField />
                    <input type="text" placeholder="Your name" value={leadName} onChange={(e) => setLeadName(e.target.value)} className="form-input" required />
                    <input type="tel" placeholder="Phone number" value={leadPhone} onChange={(e) => setLeadPhone(e.target.value)} className="form-input" required />
                    <button type="submit" className="form-submit cta-button">Contact Me</button>
                  </form>
                </div>
              ) : message.content === 'seller_lead_capture' ? (
                <div>
                  <p>To follow up on your property, I just need a few quick details:</p>
                  <form className="chat-form" onSubmit={handleSellerLeadCaptureSubmit}>
                <HoneypotField />
                    <input type="text" placeholder="Your name" value={name} onChange={(e) => setName(e.target.value)} className="form-input" required />
                    <input type="tel" placeholder="Phone number" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} className="form-input" required />
                    <input type="email" placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} className="form-input" required />
                    <button type="submit" className="form-submit cta-button">Submit</button>
                  </form>
                </div>
              ) : message.content === 'buyer_lead_capture' ? (
                <div>
                  <p>I'd love to help you find a home! Just need a few details:</p>
                  <form className="chat-form" onSubmit={handleBuyerLeadCaptureSubmit}>
                <HoneypotField />
                    <input type="text" placeholder="Your name" value={name} onChange={(e) => setName(e.target.value)} className="form-input" required />
                    <input type="tel" placeholder="Phone number" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} className="form-input" required />
                    <input type="email" placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} className="form-input" required />
                    {!pendingBuyerParams?.city && !pendingBuyerParams?.zip && (
                      <input type="text" placeholder="City or zip code" value={zipCode} onChange={(e) => setZipCode(e.target.value)} className="form-input" required />
                    )}
                    {!pendingBuyerParams?.maxPrice && (
                      <input type="number" placeholder="Max price" value={maxPrice} onChange={(e) => setMaxPrice(e.target.value)} className="form-input" />
                    )}
                    <button type="submit" className="form-submit cta-button">Search Properties</button>
                  </form>
                </div>
              ) : (
                message.content
              )}
            </div>
          ))}
          {showRegistration && (
            <div className="message bot-message">
              Please complete your registration:
              <form className="chat-form" onSubmit={handleRegistrationSubmit}>
                <input
                  type="text"
                  placeholder="Username"
                  value={regName}
                  onChange={(e) => setRegName(e.target.value)}
                  className="form-input"
                  required
                />
                <input
                  type="email"
                  placeholder="Email"
                  value={regEmail}
                  onChange={(e) => setRegEmail(e.target.value)}
                  className="form-input"
                  required
                />
                <input
                  type="password"
                  placeholder="Password"
                  value={regPassword}
                  onChange={(e) => setRegPassword(e.target.value)}
                  className="form-input"
                  required
                />
                <input
                  type="tel"
                  placeholder="Phone Number"
                  value={regPhoneNumber}
                  onChange={(e) => setRegPhoneNumber(e.target.value)}
                  className="form-input"
                  required
                />
                <input
                  type="text"
                  placeholder="Full Name"
                  value={regFullName}
                  onChange={(e) => setRegFullName(e.target.value)}
                  className="form-input"
                  required
                />
                <button type="submit" className="form-submit">Register</button>
              </form>
            </div>
          )}
          {showLogin && !showForgotPassword && (
            <div className="message bot-message">
              Please sign in:
              <form className="chat-form" onSubmit={handleLoginSubmit}>
                <input
                  type="text"
                  placeholder="Username or Email"
                  value={loginUsername}
                  onChange={(e) => setLoginUsername(e.target.value)}
                  className="form-input"
                  required
                />
                <input
                  type="password"
                  placeholder="Password"
                  value={loginPassword}
                  onChange={(e) => setLoginPassword(e.target.value)}
                  className="form-input"
                  required
                />
                <button type="submit" className="form-submit">Sign In</button>
                <button
                  type="button"
                  className="forgot-password-link"
                  onClick={() => setShowForgotPassword(true)}
                >
                  Forgot Password?
                </button>
                <button
                  type="button"
                  className="forgot-password-link"
                  onClick={() => { setShowLogin(false); setShowRegistration(true); }}
                >
                  Don't have an account? Register
                </button>
              </form>
            </div>
          )}
          {showForgotPassword && (
            <div className="message bot-message">
              Enter your email to reset your password:
              <form className="chat-form" onSubmit={handlePasswordResetSubmit}>
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={resetEmail}
                  onChange={(e) => setResetEmail(e.target.value)}
                  className="form-input"
                  required
                />
                <button type="submit" className="form-submit">Send Reset Link</button>
                <button
                  type="button"
                  className="forgot-password-link"
                  onClick={() => { setShowForgotPassword(false); setResetEmail(''); }}
                >
                  Back to Sign In
                </button>
              </form>
            </div>
          )}

        </div>
        <div className="chat-input-container" role="search">
          {!hidePrompts && (
            <div className="prompts-dropdown">
              <button
                className={`prompts-button ${user?.roles?.includes('ROLE_USER') ? 'user-role' : ''} ${(user?.roles?.includes('ROLE_ADMIN') || user?.roles?.includes('ROLE_ASSISTANT')) ? 'admin-role' : ''}`}
                onClick={() => setShowPrompts(!showPrompts)}
              >
                Prompts ▲
              </button>
              {showPrompts && (
                <div className="prompts-menu">
                  {commonPrompts.map((prompt, index) => (
                    <div
                      key={index}
                      className="prompt-item"
                      onClick={() => handlePromptSelect(prompt.value)}
                    >
                      {prompt.display}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
          <input
            type="text"
            placeholder={(sendButtonEnabled || user || openChat) ? "Type your message..." : "Please select a service above or sign in first"}
            className="chat-input"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyPress={(sendButtonEnabled || user || openChat) ? handleKeyPress : undefined}
            disabled={!(sendButtonEnabled || user || openChat) || isThinking || isPropertySearching}
            aria-label="Chat message input - Ask about properties, schedule showings, or get real estate assistance"
          />
          <button
            className="send-button" disabled={isThinking || isPropertySearching}
            onClick={(e) => {
              if (!(sendButtonEnabled || user || openChat)) {
                setShowRegistration(true);
                setSendButtonEnabled(true);
              } else {
                handleSendMessage(e);
              }
            }}
            style={{ opacity: (sendButtonEnabled || user || openChat) ? 1 : 0.5, cursor: 'pointer' }}
            aria-label="Send chat message to AI assistant"
          >
            Send
          </button>
        </div>
      </div>
      {expandedMap && (
        <div className="expanded-map-modal" onClick={() => setExpandedMap(null)}>
          <div className="expanded-map" onClick={(e) => e.stopPropagation()}>
            <button className="close-expanded-map" onClick={() => setExpandedMap(null)}>
              ×
            </button>
            <div ref={mapRef} className="leaflet-map"></div>
              <MapPlaceLayers map={placesExpandedMapInstance} />
          </div>
        </div>
      )}
      <PropertyDetailModal
        propertyDetail={propertyDetail}
        propertyDetailImages={propertyDetailImages}
        imagesLoading={imagesLoading}
        onClose={() => {
          if (directListingKey) {
            closePropertyDetail();
            navigate('/');
          } else {
            closePropertyDetail();
          }
        }}
        user={user}
        isAdmin={isAdmin}
        likedProperties={likedProperties}
        setLikedProperties={setLikedProperties}
        senderEmail={senderEmail}
        senderPassword={senderPassword}
        onLeadCaptured={({ name: n, email: e, phone: p }) => {
          setName(n);
          setEmail(e);
          setPhoneNumber(p);
        }}
      />
    </div>
  );
};

export default ActionButtons;
